import { appstr } from "../utils/appstr";
import { CompareNodes } from "../utils/CompareNodes";
import { DetermineBranchStyleNoChildren } from "../utils/DetermineBranchStyleNoChildren";
import { GetNameDefForObj } from "../utils/GetNameDefForObj.js";
import { IsAssistantStyle } from "../utils/IsAssistantStyle.js";
import { GetNodeParentObj } from "../utils/GetNodeParentObj.js";
import {
  CARD_LAYOUT_SPACING,
  enumBookScope,
  enumBoxHeightMode,
  enumBoxStyleSearch,
  enumBoxSubTypes,
  enumBoxWidthMode,
  enumBranchStyle,
  enumBSFlagOptions,
  enumCellContentType,
  enumContainerType,
  enumElementBorderStyle,
  enumFillMode,
  enumHierarchyTypes,
  enumHorzCentering,
  enumObjClassNames,
  enumObjectTypes,
  enumPersistStatus,
  enumSaveScope,
  enumSubChartFlag,
  enumSubChartOption,
  enumVertCentering,
  enumWrapTextMode,
  kFunctionalLabelWIdth,
  kIndexPageLabelWidth,
  kIndexSCID,
  kMasterSCID,
  kMaxSCSize,
  kMaxSpanOfControl,
  kTextDefSize,
  kMaxSCNodesPerDBObj
} from "../constants";
import { Globals } from "./Globals";
import { GetNameDefForClass } from "../utils/GetNameDefForClass";
import { GetFunctionalStatementFieldDef } from "../utils/GetFunctionalStatementFieldDef";
import { GetSmartBreakList } from "../utils/GetSmartBreakList";
import { NoChainOfCmd } from "../utils/NoChainOfCmd";
import { OutputSCName } from "../utils/OutputSCName";
import { QBoxLayout } from "./QBoxLayout";
import { QGenericIndex } from "./QGenericIndex";
import { QIndex } from "./QIndex";
import { QSCCandidate } from "../utils/QSCCandidate";
import { QSCMJournal } from "./QSCMJournal";
import { QSCNode } from "./QSCNode";
import { QSCNodeList } from "./QSCNodeList";
import { QSubChart } from "./QSubChart";
import { QSubChartBreak } from "./QSubChartBreak";
import { QXMLObject } from "./QXMLObject";
import { ReportTiming } from "../utils/ReportTiming";
import { SameParent } from "../utils/SameParent";
import { sc_binary_search_iterative } from "../utils/sc_binary_search_iterative";
import { SmartGetFieldValue } from "../utils/SmartGetFieldValue";
import { sc_sortedIndex } from "../utils/sc_sortedIndex";
import { StartTiming } from "../utils/StartTiming";
import { DoOptimizeHelper } from "../utils/DoOptimizeHelper";
import { CountBranch } from "../utils/CountBranch";

export function paginateRowsByHeight(cardHeights, numCols, availHeight, rowSpacing) {
  var cols = Math.max(1, numCols || 0);
  var spacing = rowSpacing > 0 ? rowSpacing : 0;
  var pages = [];
  var cardsOnPage = 0;
  var heightUsed = 0;

  for (var i = 0; i < cardHeights.length; i += cols) {
    var rowCards = Math.min(cols, cardHeights.length - i);
    var rowHeight = 0;
    for (var c = 0; c < rowCards; c++) {
      var h = cardHeights[i + c] || 0;
      if (h > rowHeight) rowHeight = h;
    }
    var rowBlock = rowHeight + spacing;

    if (cardsOnPage > 0 && heightUsed + rowBlock > availHeight) {
      pages.push(cardsOnPage);
      cardsOnPage = 0;
      heightUsed = 0;
    }

    cardsOnPage += rowCards;
    heightUsed += rowBlock;
  }

  if (cardsOnPage > 0) pages.push(cardsOnPage);
  return pages;
}

export class QSubChartMgr extends QXMLObject {
  constructor() {
    super();
    this.fUID = 1;
    this.fCurrentSubChartID = 1;

    this.fNodeList = null;
    this.fBGNodeList = null;
    //this.fNodesSorted = true;

    this.fSubChartList = null;
    this.fChangeCount = 1;
    this.fDoc = null;

    this.fMPSubChart = null;
    this.fCurrentSubChart = null;
    this.fSaveSubChartID = null;
    this.fSaveSubChart = null;
    this.fIndexSubChart = null;

    this.fSaveScope = enumSaveScope.entireChart;

    this.fRootSubChartID = 1;

    this.fSCMJournal = null;

    this.fDefNameID = null;

    this.fBranchRoot = null;
    this.fBranchSubChartCount = null;
    this.fBranchSCNodeCount = 0;
    this.fSCNodeIndex = null;

    this.fMatchCase = true;
    this.fLoadedMPTemplate = false;
    this.fNonChartNodes = null;

    this.fPageLayoutMgr = null;

    this.fManualPaginationDeltas = null;
  }

  GeneratePageSCNodes(objList, bsm, baselayout, doc, scid, subchart, topIDs, baseMRBLayout) {
    //For new objects, bring them into the SC node system and assign corresponding values to layouts.
    // this loop is fine for positions. want grouping to come later (after all nodes have been created for this sc)
    var scm = this;

    var topIDSet = new Set(topIDs);
    var coheadNodes = [];
    for (var i = 0; i < objList.length; i++) {
      const theObj = objList[i];
      const objClass = theObj.GetParentClass();

      var layout = theObj.IsHolderObj()
        ? bsm.CloneLayout(baselayout, doc)
        : bsm.CloneLayout(baseMRBLayout, doc);
      layout.SetSubChartID(scid);
      layout.SetBranchStyle(enumBranchStyle.tree);

      const scFlagDef = objClass.GetFieldDefByID("scFlag");
      const scFlag = theObj.GetFieldValue(scFlagDef);
      if (scFlag == "Down") layout.SetSubChartFlag(enumSubChartFlag.drilldown);
      else if (scFlag == "Up" || scFlag == "COC" || theObj == subchart.GetTopDBObj()) {
        layout.SetTopOptions(scFlag == "Up");
      } else if (scFlag == "breadCrumb") {
        continue;
      }
      var node = scm.AddSCNode(layout, theObj, theObj.GetObjectID());
      var myPersonID = theObj.GetObjectRecordID();
      if (topIDSet.has(myPersonID)) {
        layout.SetSubChartFlag(enumSubChartFlag.nobreak);
        coheadNodes.push(node);
      }
    }

    return coheadNodes;
  }

  CorrectDupLayouts(
    duplicates,
    recordIDIndex,
    bsm,
    doc,
    subchart,
    topIDs,
    coheadNodes,
    baselayout
  ) {
    var scm = this;
    //Run through the duplicate records we got (already in the objectDB) and assign new values to their on-page
    //layouts. Particularly important to tag subchart arrow flags.
    var priorSCID = scm.GetCurrentSubChartID();
    var scid = subchart.GetSubChartID();
    var topIDSet = new Set(topIDs);
    for (var i = 0; i < duplicates.length; i++) {
      var theID = duplicates[i]["ID"];
      var theFlag = duplicates[i]["SCFlag"];
      if (theFlag == "breadCrumb") {
        continue; //Supervisor already wired at this point, no need to do anything else
      }
      var theObj = recordIDIndex.FindObject(theID);

      var node = scm.FindSCNode(theObj, scid);
      var supervisor = theObj.GetObjectSupervisorID();
      if (!node) {
        var priorNode = scm.FindSCNode(theObj, priorSCID);
        if (priorNode) {
          //TODO: Check to see if the arrow on that node is drilldown?
          //Rare case to handle level switching
          //if (!scm.RemoveSCNode(theObj.GetObjectID(),priorSCID))
          //    failList.push(theNode);
        }
        var layout = bsm.CloneLayout(baselayout, doc);
        node = scm.AddSCNode(layout, theObj, theObj.GetObjectID());
      }

      var layout = node.GetLayout();

      layout.SetBranchStyle(enumBranchStyle.tree);
      layout.SetSubChartID(scid);
      if (theFlag == "Down") layout.SetSubChartFlag(enumSubChartFlag.drilldown);
      else if (theFlag != "0" || theID == subchart.GetTopDBObjRef()) {
        layout.SetTopOptions(theFlag == "Up");
      }
      if (topIDSet.has(theID)) {
        layout.SetSubChartFlag(enumSubChartFlag.nobreak);
        coheadNodes.push(node);
      }

      if (
        theObj.GetParent() == null &&
        !topIDSet.has(theObj.GetObjectRecordID()) &&
        !theObj.IsHolderObj()
      ) {
        //Fix for when you loaded disconnected pieces of the chart
        var supervisor = theObj.GetObjectSupervisorID();
        var parentObj = recordIDIndex.FindObject(supervisor);
        theObj.SetParent(parentObj);
      }
    }
  }

  //=================================================================================================
  WireDynSubCharts(indexes, sortkey) {
    for (var i = 0; i < this.GetNumSubCharts(); i++) {
      var aSC = this.GetIndexSubChart(i);
      var myparent = aSC["parentSCID"];
      var parentSC = indexes.FindObject(myparent);
      if (parentSC) {
        parentSC.AppendChildSubChart(aSC);
        if (sortkey) {
          var sortedChildren = parentSC.GetChildren().sort(function (param1, param2) {
            var p1 = "";
            var p2 = "";
            if (param1["scSortKey"] != null) p1 = param1["scSortKey"].toString();
            if (param2["scSortKey"] != null) p2 = param2["scSortKey"].toString();
            return p1.localeCompare(p2).toString();
          });
          parentSC.fChildren = sortedChildren;
        }
        aSC.SetParent(parentSC);
      }
    }
  }

  ResolveTopBox(objRef, subChart) {
    var doc = this.GetDoc();
    var isPosChart = doc.GetHierarchyType() === enumHierarchyTypes.positions;
    var objDB = this.GetObjDB();
    var className = isPosChart ? "Position" : "Box";
    var objClass = objDB.GetClassByName(className);

    if (isPosChart) var fieldDef = objClass.GetFieldDefByID("PositionID");
    else fieldDef = this.GetRecordIDField(objClass);

    var cPersonIDIndex = new QIndex();
    cPersonIDIndex.InitIndex(objClass, fieldDef, true, false);

    var topObj = cPersonIDIndex.FindObject(objRef);
    subChart.SetTopDBObj(topObj);

    return topObj;
  }

  LookupObjByRef(objRef) {
    if (!objRef) return null;
    try {
      if (!this._refLookupIndex) {
        var doc = this.GetDoc();
        var isPosChart = doc.GetHierarchyType() === enumHierarchyTypes.positions;
        var objDB = this.GetObjDB();
        var className = isPosChart ? "Position" : "Box";
        var objClass = objDB.GetClassByName(className);
        var fieldDef = isPosChart
          ? objClass.GetFieldDefByID("PositionID")
          : this.GetRecordIDField(objClass);
        this._refLookupIndex = new QIndex();
        this._refLookupIndex.InitIndex(objClass, fieldDef, true, false);
      }
      return this._refLookupIndex.FindObject(objRef);
    } catch (e) {
      console.warn("LookupObjByRef: index build failed for ref:", objRef, e);
      return null;
    }
  }

  WireSubChartList(metadata, subChartMetadata) {
    //Used to be called inside subchart manager's do auto breaks fxn - this was designed
    //to occur very late in the pipeline.
    this._refLookupIndex = null;
    var dynSubChartInfo = subChartMetadata;
    if (metadata["scChartBreakType"] == enumSubChartOption.nobreak) return;

    this.fSubChartList = [];
    //TODO: Needs to grab topboxid from somewhere else.
    var topBoxID = Globals._accountInfo.GetTopBoxID();
    var scidIndex = new QGenericIndex();
    scidIndex.InitIndex();

    var doCohead = metadata.IsCoHeadChart();
    var topboxids = metadata.GetTopBoxIDs();
    var nameusing = metadata.GetSubChartNameFieldID();
    if (topboxids == null) topboxids = [];

    var coheadrootscids = [];
    var sortkey = false;
    for (var i in dynSubChartInfo) {
      var scInfo = dynSubChartInfo[i];
      var theID = scInfo["scID"];
      var subChartName = scInfo["scName"];
      var objRef = scInfo["TopBoxRef"];
      if (subChartName == null || subChartName == "") subChartName = appstr("Blank");
      var subChart = new QSubChart();
      subChart.InitSubChart(theID, null, null, subChartName, nameusing, this);
      subChart.SetTopDBObjRef(objRef);
      subChart.SetSubChartFullName(scInfo["scFullName"]);
      subChart.fLoadedLevels = -1;
      subChart.fChainLoaded = 0;
      subChart["parentSCID"] = scInfo["parscID"];
      if (scInfo["scSortKey"] !== undefined) {
        subChart["scSortKey"] = scInfo["scSortKey"];
        sortkey = true;
      }
      if (topBoxID == objRef) {
        try {
          this.ResolveTopBox(objRef, subChart);
          subChart.fLoadedLevels = 2; //TODO: FIX THIS
        } catch (err) {
          console.log(":(");
        }
      } else if (topboxids.indexOf(objRef) > -1) {
        //We found a cohead.
        coheadrootscids.push(theID);
        //continue
      }

      scidIndex.AddToIndex(subChart, subChart.GetSubChartID());
      this.fSubChartList.push(subChart);
    }

    this.WireDynSubCharts(scidIndex, sortkey);
    if (doCohead) this.UpdateCoheadStructure(coheadrootscids);
  }

  UpdateCoheadStructure(coheadrootscids) {
    var rootsc = this.GetRootSubChart();

    for (var i = 0; i < coheadrootscids.length; i++) {
      var thescid = coheadrootscids[i];
      var theSC = this.FindSubChart(thescid);
      if (theSC == rootsc) continue;
      rootsc.AddTopDBObj(theSC.GetTopDBObj());
      if (rootsc.GetTopDBObj()) {
        //Handle loading into the middle of the tree. Not ideal handling but better than not doing it.
        rootsc.fOverrideField = false;
        theSC.SetParent(rootsc);
      }
      this.RemoveSubChart(thescid);
    }
  }

  //=================================================================================================
  // Initialize
  InitSubChartMgr(
    theDoc //
  ) {
    this.fDoc = theDoc;
    this.SetXMLElementName("subchartmgr");
    this.fNodeList = [];
    this.fBGNodeList = [];
    this.fSubChartList = [];
    this.fManualPaginationDeltas = [];
    this.fMPSubChart = new QSubChart();
    this.fMPSubChart.InitSubChart(kMasterSCID, null, null, "MasterPage", null, this);
  }

  PurgeData() {
    this.fNodeList = [];
    this.fBGNodeList = this.GetBackgroundNodes();
    var scList = this.GetIndexSubChart(0);
    this.fSubChartList = [];
    this.fSubChartList.push(scList);
  }

  PurgeLoadCache() {
    this.fSubChartList.forEach(subchart => (subchart.fLoadedLevels = 0));
  }

  SetPageLayoutMgr(pageLayoutMgr) {
    this.fPageLayoutMgr = pageLayoutMgr;
  }

  GetMatchCase() {
    return this.fMatchCase;
  }

  SetMatchCase(matchCase) {
    this.fMatchCase = matchCase;
  }

  GetDoc() {
    return this.fDoc;
  }

  OptimizeAssistants() {
    var theDoc = this.GetDoc();
    return theDoc.OptimizeAssistants();
  }

  GetStartAssistLeft() {
    var theDoc = this.GetDoc();
    return theDoc.GetStartAssistLeft();
  }

  AllowOptimizeSort() {
    var theDoc = this.GetDoc();
    return theDoc.AllowOptimizeSort();
  }

  HandleGroupedSort(parentList) {
    // Scan for children in the boxes and nuke their associated objects.
    // childList ordering is important here. containers are populated based on the ordering of Associated object IDs
    // the associatedObjIDs list order needs to match that of the childList
    var n = parentList.length;
    var handledContainers = new Set();
    for (var i = 0; i < n; i++) {
      var theParent = parentList[i];
      var children = theParent.GetChildList(false);
      for (var aChild = 0; aChild < children.length; aChild++) {
        var childObj = children[aChild];
        var childSCNodes = this.FindSCSubNodesFromDataObj(childObj);
        for (var aSubNode = 0; aSubNode < childSCNodes.length; aSubNode++) {
          var theSubNode = childSCNodes[aSubNode];
          var theLayout = theSubNode.GetLayout();
          if (theLayout.GetContainerObjID() != null) {
            var theContainer = this.FindSCNodeByID(
              theLayout.GetContainerObjID(),
              theLayout.GetSubChartID()
            );
            if (theContainer != null && !handledContainers.has(theContainer)) {
              var newAssocObjs = [];
              var oldAssociatedObjSet = new Set(theContainer.GetLayout().GetAssociatedObjIDs(true));
              for (var aPotentialChild = 0; aPotentialChild < children.length; aPotentialChild++) {
                var thePotentialChild = children[aPotentialChild];
                var potentialDataObjID = thePotentialChild.GetObjectID();
                if (oldAssociatedObjSet.has(potentialDataObjID))
                  newAssocObjs.push(potentialDataObjID);
              }
              if (newAssocObjs.length == oldAssociatedObjSet.size)
                theContainer.GetLayout().SetAssociatedObjIDs(newAssocObjs);
              handledContainers.add(theContainer);
            }
          }
        }
      }
    }
  }

  GetMasterPageSubChart() {
    return this.fMPSubChart;
  }

  SetMasterPageSubChartDirty(isDirty) {
    var masterSC = this.GetMasterPageSubChart();
    if (!masterSC) return false;
    masterSC.SetDirty(isDirty);
  }

  GetIndexPageSubChart() {
    return this.fIndexSubChart;
  }

  CreateRootSubChart() {
    var rootSC = this.AddSubChartObj(1, null, null, null, this.GetNameUsingID());
    this.SetCurrentSubChart(1);
    return rootSC;
  }

  CreateIndexSubChart() {
    this.fIndexSubChart = new QSubChart();
    this.fIndexSubChart.InitSubChart(kIndexSCID, null, null, "Index", null, this);

    var indexSC = this.GetIndexPageSubChart();
    var doSplit = false;
    var objDB = this.GetObjDB();
    var boxClass = objDB.GetClassByName("Box");
    var objs = boxClass.GetObjectList();
    var nameField = boxClass.GetFieldDefByID("Preferred Last");
    if (!nameField) nameField = boxClass.GetFieldDefByID("Last Name");
    if (!nameField) {
      nameField = boxClass.GetFieldDefByID("Name");
      doSplit = true;
    }
    var orphanField = boxClass.GetFieldDefByID("Orphan");

    objs = objs.filter(function (a) {
      return (
        a.GetFieldValue(orphanField) != 1 &&
        a.GetFieldValue(nameField) &&
        a.GetFieldValue(nameField).length > 1 &&
        a.IsPersistent() !== false
      );
    }); //TODO: need to remove filtered boxes, too
    objs = objs.sort(function (objA, objB) {
      var nameA = objA.GetFieldValue(nameField).toLowerCase();
      var nameB = objB.GetFieldValue(nameField).toLowerCase();
      if (doSplit && nameA.split(" ").length > 1) {
        nameA = nameA.split(" ");
        nameA.shift();
      }
      if (doSplit && nameB.split(" ").length > 1) {
        nameB = nameB.split(" ");
        nameB.shift();
      }
      if (nameA == nameB) return 0;
      else if (nameA < nameB) return -1;
      return 1;
    });

    var doc = this.GetDoc();
    var plm = doc.GetPageLayoutMgr();
    var pm = plm.GetPageMgr();
    var availWidth = plm.GetPageWidth();
    var availHeight = plm.GetPageHeight();
    var marginRect = plm.GetPageMarginsInt();
    var header = pm.GetHeaderHeight();
    var footer = pm.GetFooterHeight();
    availWidth -= marginRect.fLeft + marginRect.fRight;
    availHeight -= marginRect.fTop + marginRect.fBottom + header + footer;
    var numCols = Math.floor(availWidth / kIndexPageLabelWidth);
    var numPerPage = Math.floor(availHeight / (kTextDefSize + 4)) * numCols;

    var bsmgr = doc.GetDocMgr().fWSMgr.GetBoxStylesMgr();
    var containerLayout = bsmgr.GetLayoutByID(301, false, enumBoxStyleSearch.allSets);
    containerLayout = bsmgr.CloneLayout(containerLayout, doc);
    containerLayout.SetChartHorzCentering(enumHorzCentering.centermiddle);
    containerLayout.SetChartVertCentering(enumVertCentering.centertop);
    containerLayout.SetSubChartID(kIndexSCID);
    containerLayout.SetContainerNumCols(numCols);
    containerLayout.SetBranchStyle(enumBranchStyle.index);
    var indexID = doc.fCanvasRef.GetNextObjID();
    containerLayout.SetDBObjID(indexID);
    indexSC.fTopDBObjID = containerLayout.GetDBObjID();
    var containerNode = new QSCNode();
    containerNode.InitSCNode(containerLayout, null, indexID, this);
    var subPageNodes = [];

    indexSC.fChildren = [];
    var theID = "I0";
    for (var anObj = 0; anObj < objs.length; anObj++) {
      var theObj = objs[anObj];

      var indexLayout = this.GetIndexPageLayout(theObj);
      indexLayout.SetSubChartID(theID);
      indexLayout.SetBranchStyle(enumBranchStyle.index);
      indexLayout.SetChartHorzCentering(enumHorzCentering.centermiddle);
      indexLayout.SetChartVertCentering(enumVertCentering.centertop);
      //NOTE - purposefully am not adding to the SCNode list. They are fake.
      var dataObjID = theObj.GetObjectID();
      var newNode = new QSCNode();

      newNode.InitSCNode(indexLayout, theObj, dataObjID, this);
      subPageNodes.push(newNode);
      if ((anObj % (numPerPage - 1) === 0 || anObj >= objs.length - 1) && anObj) {
        containerLayout = bsmgr.CloneLayout(containerLayout, doc);
        containerLayout.ClearAssociatedDBObjs();
        containerLayout.SetSubChartID(theID);
        var indexID = doc.fCanvasRef.GetNextObjID();
        var name1 = theObj.GetFieldValue(nameField);
        if (doSplit && name1.split(" ").length > 1) {
          name1 = name1.split(" ");
          name1.shift();
          name1 = name1[0];
        }
        var name0 = subPageNodes[0].fDataObj.GetFieldValue(nameField);
        if (doSplit && name0.split(" ").length > 1) {
          name0 = name0.split(" ");
          name0.shift();
          name0 = name0[0];
        }
        containerLayout.SetDBObjID(indexID);
        containerNode = new QSCNode();
        containerNode.InitSCNode(containerLayout, null, indexID, this);
        doc.AddNodesToMRB(containerLayout, subPageNodes);
        subPageNodes.push(containerNode);
        var subChart = new QSubChart();
        subChart.InitSubChart(theID, indexSC, null, theID, null, this);
        subChart.fTopDBObjID = containerNode.GetDataObjID();
        subChart.fSubChartNodes = subPageNodes;
        subChart.fSubChartName = name0[0].toUpperCase() + " - " + name1[0].toUpperCase();
        subPageNodes = [];
        theID = "I" + indexSC.fChildren.length.toString();
      }
    }
  }

  //======================================================================================================================
  // NIH functional statement output
  CreateFunctionalStatementSubchart() {
    this.fIndexSubChart = new QSubChart();
    this.fIndexSubChart.InitSubChart(kIndexSCID, null, null, "Index", null, this);

    var indexSC = this.GetIndexPageSubChart();
    var objDB = this.GetObjDB();
    var boxClass = objDB.GetClassByName("Box");
    var objs = boxClass.GetObjectList();

    var doc = this.GetDoc();
    var plm = doc.GetPageLayoutMgr();
    var pm = plm.GetPageMgr();
    var availWidth = pm.GetMinPageWidth();
    var availHeight = pm.GetMinPageHeight();
    var marginRect = plm.GetPageMarginsInt();
    var header = pm.GetHeaderHeight();
    var footer = pm.GetFooterHeight();

    availWidth -= marginRect.fLeft + marginRect.fRight;
    availHeight -= marginRect.fTop + marginRect.fBottom + header + footer;

    var numCols = Math.max(1, Math.floor(availWidth / kFunctionalLabelWIdth));
    var maxStatementSize = availHeight;

    var bsmgr = doc.GetDocMgr().fWSMgr.GetBoxStylesMgr();
    var containerLayout = bsmgr.GetLayoutByID(301, false, enumBoxStyleSearch.allSets);
    containerLayout = bsmgr.CloneLayout(containerLayout, doc);
    containerLayout.SetChartHorzCentering(enumHorzCentering.centermiddle);
    containerLayout.SetChartVertCentering(enumVertCentering.centertop);
    containerLayout.SetSubChartID(kIndexSCID);
    containerLayout.SetContainerNumCols(numCols);
    containerLayout.SetBranchStyle(enumBranchStyle.index);

    var indexID = doc.fCanvasRef.GetNextObjID();
    containerLayout.SetDBObjID(indexID);
    indexSC.fTopDBObjID = containerLayout.GetDBObjID();

    var containerNode = new QSCNode();
    containerNode.InitSCNode(containerLayout, null, indexID, this);

    indexSC.fChildren = [];
    var theID = "I0";

    var cardEntries = [];
    var cardHeights = [];
    for (var anObj = 0; anObj < objs.length; anObj++) {
      var theObj = objs[anObj];
      var functionStatementLayout = this.GetFunctionalStatementPageLayout(theObj);
      functionStatementLayout.SetBranchStyle(enumBranchStyle.index);
      functionStatementLayout.SetChartHorzCentering(enumHorzCentering.centermiddle);
      functionStatementLayout.SetChartVertCentering(enumVertCentering.centertop);
      functionStatementLayout.SetDBObj(theObj);

      var aCell = functionStatementLayout.GetCellDesc(1, 3);
      var cellHeight = functionStatementLayout.CalcCellHeight(aCell);
      if (cellHeight > maxStatementSize) {
        functionStatementLayout.AdjustFontSizeOfCellToFitVHeight(aCell, maxStatementSize);
      }

      var dataObjID = theObj.GetObjectID();
      var newNode = new QSCNode();
      newNode.InitSCNode(functionStatementLayout, theObj, dataObjID, this);

      cardEntries.push({ node: newNode, layout: functionStatementLayout });
      var cardHeight = functionStatementLayout.CalcBoxHeight();
      functionStatementLayout.SetFixedHeight(cardHeight);
      cardHeights.push(cardHeight);
    }

    var pageSizes = paginateRowsByHeight(cardHeights, numCols, availHeight, CARD_LAYOUT_SPACING);

    var cardIdx = 0;
    for (var pageIdx = 0; pageIdx < pageSizes.length; pageIdx++) {
      var subPageNodes = [];
      for (var k = 0; k < pageSizes[pageIdx]; k++) {
        var entry = cardEntries[cardIdx++];
        entry.layout.SetSubChartID(theID);
        subPageNodes.push(entry.node);
      }

      var pageID = doc.fCanvasRef.GetNextObjID();
      containerLayout = bsmgr.CloneLayout(containerLayout, doc);
      containerLayout.ClearAssociatedDBObjs();
      containerLayout.SetSubChartID(theID);
      containerLayout.SetDBObjID(pageID);

      containerNode = new QSCNode();
      containerNode.InitSCNode(containerLayout, null, pageID, this);
      doc.AddNodesToMRB(containerLayout, subPageNodes);
      subPageNodes.push(containerNode);

      var subChart = new QSubChart();
      subChart.InitSubChart(theID, indexSC, null, theID, null, this);
      subChart.fTopDBObjID = containerNode.GetDataObjID();
      subChart.fSubChartNodes = subPageNodes;
      theID = "I" + indexSC.fChildren.length.toString();
    }
  }

  GetDisconnectedBranches() {
    return this.fDoc.fDocMgr.fDisconnectedBranches;
  }

  GetFunctionalStatementPageLayout(dataObj) {
    var theLayout = new QBoxLayout();
    theLayout.InitBoxLayout(kFunctionalLabelWIdth, 1, 3);
    theLayout.SetBoxStyleID(-1);
    theLayout.SetBorderStyle(enumElementBorderStyle.noBorder);
    theLayout.SetWidthSizingMode(enumBoxWidthMode.fixedwidth);
    theLayout.SetHeightSizingMode(enumBoxHeightMode.fixedheight);
    theLayout.SetPosition(0, 0);

    theLayout.SetWidthMin(kFunctionalLabelWIdth);
    theLayout.SetWidthMax(768);
    theLayout.SetBoxPadding(20);
    theLayout.SetBoxFillMode(enumFillMode.noFill);

    var aClass = dataObj.GetParentClass();
    var functionNameFD = aClass.GetTitleFieldDef();
    var functionStatementFD = GetFunctionalStatementFieldDef(aClass);

    var functionNameCell = theLayout.GetCellDesc(1, 1);
    functionNameCell.SetAlignment("center");
    functionNameCell.SetWrapText(enumWrapTextMode.unlimited);
    functionNameCell.SetFontSize(kTextDefSize);
    functionNameCell.SetTextBold(true);
    functionNameCell.SetCellContentType(enumCellContentType.Field);
    functionNameCell.SetField(functionNameFD);

    var functionStatementCell = theLayout.GetCellDesc(1, 3);
    functionStatementCell.SetWrapText(enumWrapTextMode.unlimited);
    functionStatementCell.SetAlignment("left");
    functionStatementCell.SetFontSize(kTextDefSize);
    functionStatementCell.SetCellContentType(enumCellContentType.Field);
    functionStatementCell.SetField(functionStatementFD);
    functionStatementCell.SetMaxCellRows(100);

    theLayout.CalculateLayout();

    return theLayout;
  }

  //==============================================================================
  // Undo/Redo Support
  StartJournal() {
    this.fSCMJournal = new QSCMJournal();
    this.fSCMJournal.InitJournal(this);
  }

  SetSubChartList(subChartList) {
    this.fSCMJournal.SubChartListChanged(this.fSubChartList);
    this.fSubChartList = subChartList;
  }

  SetSCNodeList(scNodeList) {
    this.JournalSCNodeList();
    this.fNodeList = scNodeList;
  }

  JournalSubChartChg(subChart) {
    if (this.fSCMJournal) this.fSCMJournal.JournalSubChartChg(subChart);
  }

  JournalLayoutChg(aLayout) {
    if (this.fSCMJournal) this.fSCMJournal.JournalLayoutChg(aLayout);
  }

  JournalPaginationChg() {
    if (this.fSCMJournal) this.fSCMJournal.JournalPaginationChg(this.fManualPaginationDeltas);
  }

  ClearJournal() {
    this.fSCMJournal = null;
  }

  GetJournal() {
    var j = this.fSCMJournal;
    if (j && j.JournalChanged()) return j;
    else return null;
  }

  RestoreJournal(aJournal) {
    var updateCode = aJournal.GetUpdateCode();
    this.StartJournal();
    aJournal.Restore();

    return updateCode;
  }

  //=================================================================================================
  // General
  GetNextUID() {
    this.fUID++;
    return this.fUID;
  }

  //=================================================================================================
  // SC Nodes
  /**
   * @returns {QSCNode[]}
   */
  GetSCNodeList() {
    return this.fNodeList;
  }

  GetPositionSCNodeList(scID) {
    var scNodes = this.GetNodesForSubChart(scID, false);
    return scNodes.filter(node => node.IsPositionSCNode());
  }

  GetHolderSCNodeList(scID) {
    var scNodes = this.GetNodesForSubChart(scID, false);
    return scNodes.filter(node => node.IsHolderSCNode());
  }

  GetHolderNodesForPosition(posNode) {
    var posObj = posNode.GetDataObj();
    var holderObjs = posObj.GetHolderList();
    var holderNodes = [];
    for (const i in holderObjs) {
      var holder = holderObjs[i];
      var nodes = this.FindSCSubNodesFromDataObj(holder);
      holderNodes.push(...nodes);
    }

    return holderNodes;
  }

  GetBackgroundNodes() {
    var doc = this.GetDoc();
    var bgMgr = doc.GetDocMgr().fWSMgr.fBackgroundMgr;
    return bgMgr.GetBackgroundNodes();
  }

  GetBackgroundNodeState() {
    return this.GetNodesForSubChart(kMasterSCID, false);
  }

  GetIndexPageSCNodeList() {
    var indexSC = this.GetIndexPageSubChart();
    var indexPageNodes = indexSC.fSubChartNodes;
    //TODO- fail at this point if null

    return indexPageNodes;
  }

  GetIndexPageLayout(dataObj) {
    var theLayout = new QBoxLayout();
    theLayout.InitBoxLayout(kIndexPageLabelWidth, 1, 1);
    theLayout.SetBoxStyleID(-1);
    theLayout.SetBorderStyle(enumElementBorderStyle.noBorder);
    theLayout.SetWidthSizingMode(enumBoxWidthMode.fixedwidth);
    theLayout.SetHeightSizingMode(enumBoxHeightMode.fixedheight);
    theLayout.SetPosition(0, 0);

    theLayout.SetWidthMin(kIndexPageLabelWidth);
    theLayout.SetWidthMax(768);
    theLayout.SetBoxPadding(1);
    theLayout.SetBoxFillMode(enumFillMode.noFill);

    var c1 = theLayout.GetCellDesc(1, 1);
    c1.SetAlignment("left");
    c1.SetFontSize(kTextDefSize);
    c1.SetCellContentType(enumCellContentType.Field);
    var f1 = GetNameDefForObj(dataObj);
    c1.SetField(f1);

    theLayout.CalculateLayout();
    theLayout.SetDBObj(dataObj);

    return theLayout;
  }

  JournalSCNodeList() {
    if (this.fSCMJournal) this.fSCMJournal.SCNodeListChanged(this.fNodeList);
  }

  SortNodes() {
    this.fNodeList.sort(CompareNodes);
    //  this.fNodesSorted = true;
  }

  AddToNodeList(newNode) {
    //  if (this.fNodesSorted)
    //  {
    var matchIdx = sc_sortedIndex(this.fNodeList, newNode.GetDataObjID());
    this.fNodeList.splice(matchIdx, 0, newNode);
    // }
    // else
    //     this.fNodeList.push(newNode);
  }

  AddToBGList(newNode) {
    //  if (this.fNodesSorted)
    //  {
    var matchIdx = sc_sortedIndex(this.fBGNodeList, newNode.GetDataObjID());
    this.fBGNodeList.splice(matchIdx, 0, newNode);
    // }
    // else
    //     this.fNodeList.push(newNode);
  }

  AddSCNode(layout, dataObj, dataObjID) {
    this.JournalSCNodeList();

    var newNode = new QSCNode();
    newNode.InitSCNode(layout, dataObj, dataObjID, this);
    layout.SetSCNodeRef(newNode);
    layout.SetDBObjID(dataObjID);
    if (dataObj) layout.SetDBObj(dataObj);

    var curSubChartID = newNode.GetSubChartID();
    if (curSubChartID === kMasterSCID) {
      this.AddToBGList(newNode);
    } else {
      this.AddToNodeList(newNode);
    }

    //	console.log("Adding SCNode. SubchartID:" + curSubChartID);
    return newNode;
  }

  GetSCNodeCount(isBG) {
    return isBG ? this.GetBGNodeCount() : this.fNodeList.length;
  }

  GetIndexSCNode(index, isBG) {
    return isBG ? this.GetIndexBGNode(index) : this.fNodeList[index];
  }

  GetBGNodeCount() {
    return this.fBGNodeList.length;
  }

  GetIndexBGNode(index) {
    return this.fBGNodeList[index];
  }

  FindSCNodeIndex(dataObjID, subChartID) {
    return this.FastFindSCSubNodeIndex(dataObjID, subChartID, true);
  }

  FindSCNode(dataObj, subChartID) {
    var dataObjID = dataObj.GetObjectID();

    // Faster search
    return this.FindSCNodeByID(dataObjID, subChartID);
  }

  FindSCNodeByID(dataObjID, subChartID) {
    // Faster search
    if (this.fSCNodeIndex != null) {
      var nodeList = this.FindSCNodeList(subChartID);
      if (nodeList == null) return null;

      var n = nodeList.length;
      for (var i = 0; i < n; i++) {
        var scn = nodeList[i];
        if (scn.fDataObjID == dataObjID) return scn;
      }
      return null;
    }

    var nodeIndex = this.FindSCNodeIndex(dataObjID, subChartID);
    if (nodeIndex != -1) return this.GetIndexSCNode(nodeIndex, subChartID === kMasterSCID);

    return null;
  }

  GetSCNodeMapByDataObjID(subChartID) {
    var map = new Map();
    if (this.fSCNodeIndex != null) {
      var nodeList = this.FindSCNodeList(subChartID);
      if (nodeList) {
        for (var i = 0; i < nodeList.length; i++) {
          map.set(nodeList[i].fDataObjID, nodeList[i]);
        }
      }
      return map;
    }
    var n = this.GetSCNodeCount();
    for (var i = 0; i < n; i++) {
      var scn = this.GetIndexSCNode(i);
      if (scn.GetLayout().GetSubChartID() === subChartID) {
        map.set(scn.GetDataObjID(), scn);
      }
    }
    return map;
  }

  CheckSCNode(dataObjID, matchIdx, subChartID, matchSCID) {
    if (matchIdx < 0) return false;

    var isBG = subChartID === 0;
    var n = this.GetSCNodeCount(isBG);
    if (matchIdx >= n) return false;

    var scn = this.GetIndexSCNode(matchIdx, isBG);
    var scnObjID = scn.GetDataObjID();
    if (scnObjID != dataObjID) return false;

    var scID = scn.GetSubChartID();
    if (matchSCID) {
      if (scID == subChartID) return true;
    } else {
      if (scID != subChartID) return true;
    }

    return false;
  }

  FastFindSCSubNodeIndex(dataObjID, parentSubChartID, doMatchSC) {
    const nodes = parentSubChartID === 0 ? this.fBGNodeList : this.fNodeList;
    if (!nodes || nodes.length === 0) return -1;

    const matchIdx = sc_binary_search_iterative(nodes, dataObjID);
    if (matchIdx == null || matchIdx < 0) return -1;

    const nodesLength = nodes.length;
    if (matchIdx >= nodesLength) return -1;

    let currentIdx = matchIdx;

    while (currentIdx < nodesLength) {
      const node = nodes[currentIdx];

      if (node.fDataObjID !== dataObjID) break;

      const scID = node.GetSubChartID();
      if ((doMatchSC && scID == parentSubChartID) || (!doMatchSC && scID != parentSubChartID)) {
        return currentIdx;
      }

      currentIdx++;
    }

    return -1;
  }

  FindSCSubNodeIndex(dataObjID, parentSubChartID) {
    return this.FastFindSCSubNodeIndex(dataObjID, parentSubChartID, false);
  }

  FindSCSubNodesFromDataObj(dataObj) {
    var dataObjID = dataObj.GetObjectID();
    return this.FindSCSubNodesFromDataObjID(dataObjID);
  }

  FindSCSubNodesFromPersonID(personID) {
    return this.FindSCSubNodesFromRecordID(personID, enumObjClassNames.box);
  }

  FindSCSubNodesFromRecordID(recordID, objType = enumObjClassNames.box) {
    var objDB = this.GetObjDB(); //fObjDB;
    var boxClass = objDB.GetClassByName(objType);
    var fieldDef = this.GetRecordIDField(boxClass);

    recordID = this.PrepVal(recordID); // .toString();
    // OptimizeSC
    var matchlist = [];
    for (var i = 0; i < this.fNodeList.length; i++) {
      var scn = this.GetIndexSCNode(i); // fNodeList[i];
      var dataObj = scn.GetDataObj();
      if (dataObj == null) continue;
      var SCRecordID = dataObj.GetFieldValue(fieldDef);
      if (SCRecordID == null) {
        continue;
      }
      if (this.PrepVal(SCRecordID) === recordID) matchlist.push(scn);
    }

    return matchlist;
  }

  FindSCSubNodesFromDataObjID(dataObjID) {
    var matchlist = [];
    const nodes = this.fNodeList;

    const startIdx = sc_binary_search_iterative(nodes, dataObjID);
    if (startIdx == null) return matchlist;

    let currentIdx = startIdx;
    while (currentIdx < nodes.length && nodes[currentIdx].fDataObjID === dataObjID) {
      if (matchlist.length >= kMaxSCNodesPerDBObj) {
        break;
      }

      matchlist.push(nodes[currentIdx]);
      currentIdx++;
    }

    return matchlist;
  }

  RemoveSCNode(dataObjID, subChartID) {
    var index = this.FindSCNodeIndex(dataObjID, subChartID);
    var nodes = subChartID === 0 ? this.fBGNodeList : this.fNodeList;
    if (index != -1) {
      this.JournalSCNodeList();
      nodes.splice(index, 1);
      return true;
    }
    return false;
  }

  DiscardTopNode(scNodes) {
    var updatedNodes = [];
    var o = scNodes.length;
    for (var k = 0; k < o; k++) {
      var scNode = scNodes[k];
      if (!scNode.TopOfBreak()) updatedNodes.push(scNode);
    }

    return updatedNodes;
  }

  GetAllChildSCNodes(dataObj) {
    var scNodeList = [];
    var childList = [];
    childList.push(dataObj);
    dataObj.GetAllChildren(childList);
    var n = childList.length;
    for (var i = 0; i < n; i++) {
      var childObj = childList[i];
      var objID = childObj.GetObjectID();

      var scNodes = this.FindSCSubNodesFromDataObjID(objID);
      var o = scNodes.length;
      if (childObj == dataObj) {
        scNodes = this.DiscardTopNode(scNodes);
        o = scNodes.length;
      }

      for (var k = 0; k < o; k++) {
        var scNode = scNodes[k];
        scNodeList.push(scNode);
      }
    }

    return scNodeList;
  }

  RemoveChildrenSubCharts(removeList) {
    // Remove subchart breaks
    for (var i = 0; i < removeList.length; i++) {
      var childObj = removeList[i];
      var isTop = childObj.TopOfSubChart();
      if (isTop == 1) {
        var objID = childObj.GetObjectID();
        var scNodes = this.FindSCSubNodesFromDataObjID(objID);
        var o = scNodes.length;
        for (var k = 0; k < o; k++) {
          var scNode = scNodes[k];
          if (scNode.TopOfBreak())
            this.RemoveSubChartBreak(scNode.GetLayout(), childObj, objID, false);
        }
      }
    }
  }

  RemoveChildren(dataObj) {
    var removeList = [];
    dataObj.GetAllChildren(removeList);

    this.RemoveChildrenSubCharts(removeList);

    // OptimizeSC
    // Remove the objects
    for (var i = 0; i < removeList.length; i++) {
      var childObj = removeList[i];
      childObj.SetParent(null, -1);
      childObj.SetPersistent(false);

      var m = this.GetSCNodeCount();
      var childID = childObj.GetObjectID();

      // Remove from SCNodeList
      var j = 0;
      var done = false;
      while (!done) {
        var scn = this.GetIndexSCNode(j);
        // var scn = this.fNodeList[j];
        var scDBID = scn.GetDataObjID();
        if (scDBID == childID) {
          // Found it - now remove it
          this.JournalSCNodeList();
          this.fNodeList.splice(j, 1);
          done = true;
        }
        j++;
        if (j >= m) done = true; // Shouldn't happen
      }
    }
  }

  DetermineMRBBreakType(baseMRB, fullSelection) {
    var mrbDrillSetting = baseMRB.GetSubChartFlag();
    if (baseMRB["overrideRemove"]) {
      delete baseMRB["overrideRemove"];
      return enumSubChartFlag.nobreak;
    }
    for (var aChild in fullSelection) {
      var theBox = fullSelection[aChild];
      if (theBox.GetSubChartFlag() != enumSubChartFlag.nobreak) {
        if (theBox.GetSubChartFlag() == enumSubChartFlag.drilldown) {
          mrbDrillSetting = enumSubChartFlag.drilldown;
        } else {
          mrbDrillSetting = enumSubChartFlag.drillup;
          //Any box with drillup overrides the other behavior.
          break;
        }
      } else if (!theBox.GetDataObj().GetParent()) {
        mrbDrillSetting = enumSubChartFlag.nobreak;
        break;
      }
    }

    return mrbDrillSetting;
  }

  //This function takes care of the boxes on the current page and updates the SC nodes on other pages properly.
  UpdateMRBBreaks(baseMRB, fullSelection) {
    //The SCSubNodes will all need to be together in the new subchart.
    //Should this function be externalized to work purely off SCNodes?

    //STEP 1: Figure out if any boxes have Subchart Breaks
    var mrbDrillSetting = this.DetermineMRBBreakType(baseMRB, fullSelection);
    var targetLayout = baseMRB.GetLayout();
    targetLayout.SetSubChartFlag(mrbDrillSetting);
    var origSubChartID = targetLayout.GetSubChartID();
    var matchContaineridx = this.FindSCSubNodeIndex(baseMRB.GetDataObjID(), origSubChartID);

    var subNodeDrillSetting =
      mrbDrillSetting == enumSubChartFlag.drillup
        ? enumSubChartFlag.drilldown
        : enumSubChartFlag.drillup;
    var theMatchContainer = null;
    if (matchContaineridx > -1) {
      //We have an existing off page subchart
      theMatchContainer = this.GetIndexSCNode(matchContaineridx);
      newSubChartID = theMatchContainer.GetSubChartID();
      var existingMatchLayout = theMatchContainer.GetLayout();
    }

    if (mrbDrillSetting == enumSubChartFlag.drilldown) {
      //We know we have a break down on our box.
      var scSubNodes = [];
      var rootNode = null;
      var newSubChartID = null; //Will be updated by the first subchart that gets hit. Make sure this box is index 0.
      var childrenSubChartsToReassign = [];
      //2. Determine the new destination subchart for every child, and ensure the root node for that subchart has been identified.
      for (var boxIdx = 0; boxIdx < fullSelection.length; boxIdx++) {
        var theBox = fullSelection[boxIdx];
        var boxLayout = theBox.GetLayout();
        var SCNodes = this.FindSCSubNodesFromDataObj(theBox.GetDataObj());
        var topNodeidx = this.FindSCSubNodeIndex(theBox.GetDataObjID(), origSubChartID);

        //var topNodes = SCNodes.filter(function(a){return a.GetSubChartID() !== origSubChartID});
        //var theTopNode = null;
        //if (topNodes.length > 1)
        //console.log("what??");
        if (topNodeidx > -1) {
          theTopNode = this.GetIndexSCNode(topNodeidx);
          //We found an existing off-subchart node
          if (!newSubChartID) {
            //And we have not yet found an existing off-page subchart, so this is our subchart.
            newSubChartID = theTopNode.GetSubChartID();
            rootNode = theTopNode;
          } else if (
            theTopNode.GetSubChartFlag() === subNodeDrillSetting &&
            theTopNode.GetSubChartID() != newSubChartID
          ) {
            //We have an existing off page subchart, but this box had its own subchart already. Remove it.
            var subChartToRemoveID = theTopNode.GetSubChartID();
            var subChartToRemove = this.FindSubChart(subChartToRemoveID);
            childrenSubChartsToReassign = childrenSubChartsToReassign.concat(
              subChartToRemove.fChildren
            );
            this.RemoveSubChartBreak(boxLayout, theBox.GetDataObj(), theBox.GetDataObjID(), false);
            //NOTE - because we no longer alter the subchart flag in most other scenarios, we need to do it here as we are removing the subchart
            //break but it still 'exists' on the container level - removing it would drop the subchart break when box is moved out.
            boxLayout.SetSubChartFlag(mrbDrillSetting);
            //TODO: Need to make sure children subcharts are added to the new subchart.
            var clonedLayout = boxLayout.Clone();
            clonedLayout.SetSubChartFlag(subNodeDrillSetting);
            scSubNodes.push(
              this.AddSCNode(clonedLayout, theBox.GetDataObj(), theBox.GetDataObjID())
            );
          } else scSubNodes.push(theTopNode);
        } else {
          //We need to duplicate this scNode for use in our child subchart if the box didn't have an opposite node already.
          // ^ not for servercharts... subchart query should handle that.
          if (SCNodes.length < 2 && !this.fDoc.IsServerChart()) {
            var clonedLayout = boxLayout.Clone();
            scSubNodes.push(
              this.AddSCNode(clonedLayout, theBox.GetDataObj(), theBox.GetDataObjID())
            );
          }
        }
      }
      //Update children subchart nodes with new subchart
      for (var aSubNode = 0; aSubNode < scSubNodes.length; aSubNode++) {
        var theNode = scSubNodes[aSubNode];
        origSubChartID = theNode.GetLayout().GetSubChartID();
        this.UpdateSubChartID(theNode, origSubChartID, newSubChartID);
      }
      //Update children subcharts with new subchart

      if (rootNode) scSubNodes.unshift(rootNode);
      if (newSubChartID != null) {
        var newSubChart = this.FindSubChart(newSubChartID);
        //Note- it is possible that we could end up removing the topDBOBj from the newSubChart.
        var dataObjArr = scSubNodes.map(function (a) {
          return a === null ? null : a.fDataObj;
        });
        //TODO: this is partially unsafe? Don't want to switch top obj if its other than index 0
        newSubChart.SetTopDBObj(dataObjArr[0]);
        newSubChart.SetTopDBObjArr(dataObjArr);
        for (var aChildSCToReassign in childrenSubChartsToReassign) {
          //Since the break was removed, they would have been incorrectly placed in the top subchart, not the new bottom one.
          var theSubChart = childrenSubChartsToReassign[aChildSCToReassign];
          var parent = theSubChart.GetSubChartParent();
          parent.RemoveChild(theSubChart);
          newSubChart.AppendChildSubChart(theSubChart);
          theSubChart.SetParent(newSubChart);
        }

        //TODO: If we had an existing bottom layout, use that one isntead of re-creating it here.
        var c = targetLayout.Clone();
        c.SetTopOptions(true);
        c.SetSubChartID(newSubChartID);
        c.SetBranchStyle(enumBranchStyle.tree);
        c.SetAssociatedObjIDs([]);
        c.SetDBObjID(baseMRB.GetDataObjID());
        var newMRBNode = this.GetDoc().GroupNodes(scSubNodes, false, c);
        return newMRBNode;
      }
    } else {
      //If we're adjusting a subchart top, handle it properly.
      for (var boxIdx = 0; boxIdx < fullSelection.length; boxIdx++) {
        var theBox = fullSelection[boxIdx];
        var curSCID = theBox.GetLayout().GetSubChartID();
        var curSC = this.FindSubChart(curSCID);
        if (curSC.GetTopDBObj() == theBox.GetDataObj()) {
          this.IncChangeCount();
          var dataObjArr = fullSelection.map(function (a) {
            return a === null ? null : a.fDataObj;
          });
          curSC.SetTopDBObjArr(dataObjArr);
          break;
        }
      }
      //Remove subchart breaks if they exist in this unusual case (coheads)
      for (var boxIdx = 0; boxIdx < fullSelection.length; boxIdx++) {
        var theBox = fullSelection[boxIdx];
        if (theBox.GetSubChartFlag() == enumSubChartFlag.drilldown)
          this.RemoveSubChartBreak(
            theBox.GetLayout(),
            theBox.GetDataObj(),
            theBox.GetDataObjID(),
            false
          );
      }
      //Finally, special handling is needed so that if we drill up, we see the mirroring SCnodes.
      //CHECK FOR THEM EXISTING FIRST BEFORE YOU DO THIS- don't duplicate already done labor!
      if (mrbDrillSetting == enumSubChartFlag.drillup) {
        var scSubNodes = [];
        for (var boxIdx = 0; boxIdx < fullSelection.length; boxIdx++) {
          var theBox = fullSelection[boxIdx];
          var subNodeIdx = this.FindSCSubNodeIndex(theBox.GetDataObjID(), origSubChartID);
          if (subNodeIdx > 0) {
            var theTopNode = this.GetIndexSCNode(subNodeIdx);
            if (!newSubChartID) newSubChartID = theTopNode.GetSubChartID();
            scSubNodes.push(theTopNode);
          } else {
            var clonedLayout = theBox.GetLayout().Clone();
            clonedLayout.SetSubChartFlag(subNodeDrillSetting);
            clonedLayout.SetSubChartID(newSubChartID);
            scSubNodes.push(
              this.AddSCNode(clonedLayout, theBox.GetDataObj(), theBox.GetDataObjID())
            );
          }
        }
        if (theMatchContainer) {
          //We had an existing match container on the other page.
          var c = existingMatchLayout;
        } else {
          //NOTE: This block should only be called in MANUAL grouping cases- should not be called programatically.
          //No container exists yet.
          var c = targetLayout.Clone();
          c.SetAssociatedObjIDs([]);
          c.SetDBObjID(baseMRB.GetDataObjID());
          c.SetSubChartID(newSubChartID);
          c.SetSubChartFlag(subNodeDrillSetting);
        }
        var newMRBNode = this.GetDoc().GroupNodes(scSubNodes, false, c);
        return newMRBNode;
      }
    }
    return null;
  }

  //=================================================================================================
  // Manage Subchart Objects
  GetNumSubCharts() {
    return this.fSubChartList.length;
  }

  GetSubChartList() {
    return this.fSubChartList;
  }

  RecurseChildren(curRoot, childList, pageNum) {
    childList.push(curRoot);
    if (pageNum == childList.length) return curRoot;

    var numChildren = curRoot.ChildCount();
    for (var i = 0; i < numChildren; i++) {
      var childSubChart = curRoot.GetIndexChild(i);
      var targetPage = this.RecurseChildren(childSubChart, childList, pageNum);
      if (targetPage) return targetPage;
    }

    return null;
  }

  GetSubChartByPageNum(pageNum) {
    var rootSC = this.GetRootSubChart();

    var childList = [];
    return this.RecurseChildren(rootSC, childList, pageNum);
  }

  FindSubChartIndex(subChartID) {
    var n = this.GetNumSubCharts();
    for (var i = 0; i < n; i++) {
      var sc = this.fSubChartList[i];
      if (sc.GetSubChartID() == subChartID) return i;
    }

    return -1;
  }

  FindSubChart(subChartID) {
    var list = this.fSubChartList;
    if (!list) return null;

    // Lazily build/rebuild map for O(1) lookup
    if (
      !this._subChartMap ||
      this._subChartMapSrc !== list ||
      this._subChartMapLen !== list.length
    ) {
      this._subChartMap = new Map();
      for (var i = 0; i < list.length; i++) {
        var sc = list[i];
        this._subChartMap.set(sc.GetSubChartID(), sc);
      }
      this._subChartMapSrc = list;
      this._subChartMapLen = list.length;
    }

    var result = this._subChartMap.get(subChartID);
    return result !== undefined ? result : null;
  }

  FindTopObjFromLayout(layout) {
    var scID = layout.GetSubChartID();
    var sc = this.FindSubChart(scID);
    var topObj = sc.GetTopDBObj();

    return topObj;
  }

  GetCurrentSubChartID() {
    return this.fCurrentSubChartID;
  }

  ValidateSubChart(subChart) {
    var index = this.GetIndexOfSubChart(subChart);
    if (index == -1) {
      var pSC = subChart.GetSubChartParent();
      if (pSC == null) subChart = this.GetIndexSubChart(0);
      else subChart = this.ValidateSubChart(pSC);
    }

    return subChart;
  }

  GetCurrentSubChart() {
    return this.fCurrentSubChart;
  }

  StoreCurrentSubChart() {
    this.fSaveSubChartID = this.fCurrentSubChartID;
    this.fSaveSubChart = this.fCurrentSubChart;
  }

  RecallCurrentSubChart() {
    return this.fSaveSubChartID;
  }

  GetCurrentSubChartName() {
    var csc = this.GetActiveSubChart(); //What context would we ever want to see the master page here?
    var scName = csc.GetSubChartName();
    if (scName == "MasterPage")
      // Need to localize...
      scName = "<" + appstr("Subchart") + ">";
    return scName;
  }

  // Active subchart does not include the masterpage subchart
  SetLoadedStatus(scID, loaded) {
    var sc = this.FindSubChart(scID);
    if (sc) {
      sc.fPageLoaded = loaded;
    }
  }

  GetActiveSubChart() {
    var asc = this.GetCurrentSubChart();
    if (asc != null) {
      if (asc.GetSubChartID() == 0) {
        if (this.fSaveSubChart) asc = this.fSaveSubChart;
        else if (this.fSaveSubChartID) asc = this.FindSubChart(this.fSaveSubChartID);
      }
    }
    return asc;
  }

  SetBranchRoot(branchRootSC, branchScope) {
    const initialRootSC = this.fBranchRoot;
    const initialSCCount = this.fBranchSubChartCount;
    this.fBranchRoot = branchRootSC;
    switch (branchScope) {
      case enumBookScope.page:
        this.fBranchSubChartCount = 1;
        break;
      case enumBookScope.branch:
        this.fBranchSubChartCount = CountBranch(branchRootSC);
        break;
      case enumBookScope.entire:
        this.fBranchSubChartCount = null;
        break;
    }

    if (initialRootSC != this.fBranchRoot || initialSCCount != this.fBranchSubChartCount) {
      this.CountBranchSCNodes(branchScope);
    }
  }

  CountBranchSCNodes(branchScope) {
    const branchRoot = this.fBranchRoot;
    let nodeList = [];

    switch (branchScope) {
      case enumBookScope.page:
        const subChartID = branchRoot.GetSubChartID();
        nodeList = this.GetNodesForSubChart(subChartID, false);
        break;
      case enumBookScope.branch:
        this.GetNodesForSubChartBranch(branchRoot, nodeList);
        break;
      case enumBookScope.entire:
        nodeList = this.GetSCNodeList();
        break;
    }

    this.fBranchSCNodeCount = nodeList.length;
    return this.fBranchSCNodeCount;
  }

  GetRootSubChart() {
    if (this.fBranchRoot == null) return this.GetIndexSubChart(0);
    else return this.fBranchRoot;
  }

  GetActivePageNumber() {
    if (Globals._bookRenderInfo)
      return Globals._bookRenderInfo.fNumPages - Globals._bookRenderInfo.fPageRetryQ.length;

    var currentSC = this.GetCurrentSubChart();
    if (!currentSC) return 0;
    var pagenumber = currentSC.GetPageNumber();

    return pagenumber;
  }

  GetActiveSubChartName() {
    var csc = this.GetActiveSubChart();
    if (csc != null) return csc.GetSubChartName();

    return appstr("Master");
  }

  GetActiveBranchPages(indexOverride) {
    if (this.fBranchRoot) return this.fBranchSubChartCount;
    else if (Globals._bookRenderInfo && !indexOverride)
      //This is awful.
      return Globals._bookRenderInfo.fNumPages;
    else {
      var activeSubChart = this.GetCurrentSubChart();
      if (!activeSubChart) return 0;
      var rootSubChart = activeSubChart.GetRootSubChart();
      var numPages = rootSubChart.GetTotalPages();
      if (rootSubChart.GetSubChartID() != kIndexSCID) numPages += 1;
      return numPages;
    }
  }

  GetActiveSubChartNum() {
    var csc = this.GetActiveSubChart();
    if (csc != null) return csc.GetSubChartNum();

    return "0";
  }

  GetSubChartPath(aSubChart, forceShowNum) {
    var s = aSubChart.GetSubChartName(forceShowNum);
    var p = aSubChart.GetSubChartParent();
    if (aSubChart == this.fBranchRoot) p = null;

    while (p != null) {
      s = p.GetSubChartName(forceShowNum) + "\\" + s;
      if (p == this.fBranchRoot) p = null;
      else p = p.GetSubChartParent();
    }

    return s;
  }

  GetActiveSubChartPath(showSCNum) {
    var csc = this.GetActiveSubChart();
    if (csc == null) return appstr("Master");

    var s = this.GetSubChartPath(csc, showSCNum);

    /*
	var s = csc.GetSubChartName();
	var p = csc.GetSubChartParent();
	while (p != null)
	{
	 	s = p.GetSubChartName() + "\\" + s;
		p = p.GetSubChartParent();
	}
	*/

    return s;
  }

  GetChainOfCommand() {
    var csc = this.GetActiveSubChart();
    if (csc == null) return NoChainOfCmd();

    var topObj = csc.GetTopDBObj();
    if (topObj == null) return NoChainOfCmd();

    var f = GetNameDefForObj(topObj); // topObj.GetFieldDefByID("Name");
    if (f == null) return NoChainOfCmd();

    //var s = topObj.GetChainOfCommand();

    var s = SmartGetFieldValue(topObj, f);
    var pObj = topObj.GetParent();
    while (pObj != null) {
      s = SmartGetFieldValue(pObj, f) + " > " + s;
      pObj = pObj.GetParent();
    }

    return s;
  }

  GetCurrentTopObj() {
    var sc = this.GetCurrentSubChart();
    var topObj = sc.GetTopDBObj();

    return topObj;
  }

  GetObjDB() {
    var theDoc = this.GetDoc();
    var objDB = theDoc.GetObjDB();
    return objDB;
  }

  TempSetTopObj(topObj) {
    var objDB = this.GetObjDB();
    objDB.SetSubChartContext(topObj);
  }

  ResetTopObj(topObj) {
    var sc = this.GetCurrentSubChart();
    var objDB = this.GetObjDB();

    objDB.SetSubChartContext(sc.GetTopDBObj());
  }

  SetCurrentSubChart(subChartID) {
    this.fCurrentSubChartID = subChartID;

    var sc = this.fCurrentSubChart;

    if (typeof subChartID == "string") {
      for (var aChildSubChart in this.fIndexSubChart.fChildren) {
        var theChildSubChart = this.fIndexSubChart.fChildren[aChildSubChart];
        if (theChildSubChart.GetSubChartID() == subChartID) {
          sc = theChildSubChart;
          break;
        }
      }
    } else {
      switch (subChartID) {
        case kMasterSCID:
          sc = this.fMPSubChart;
          break;
        case kIndexSCID:
          sc = this.fIndexSubChart.fChildren[0];
          break;
        default:
          sc = this.FindSubChart(subChartID);
          break;
      }
    }
    if (sc) {
      this.fCurrentSubChart = sc;

      var objDB = this.GetObjDB();
      objDB.SetSubChartContext(sc.GetTopDBObj());
    } else console.log("ERROR - ATTEMPTED TO SWTICH TO INVALID SUBCHART");
  }

  FindSubChartSubID(dataObjID, parentSubChartID) {
    var index = this.FindSCSubNodeIndex(dataObjID, parentSubChartID);
    var scn = this.GetIndexSCNode(index, parentSubChartID === kMasterSCID);
    if (scn == null) return -1;

    return scn.GetSubChartID();
  }

  RemoveSCNodes(scid, boxClass, subchart, o) {
    var scm = this;
    //Remove nodes when we drop down # of levels.
    var nodes = scm.GetNodesForSubChart(scid);
    var failList = [];
    o.SetSubChartContext(subchart.GetTopDBObj());
    var objIDSet = new Set(
      nodes.map(function (a) {
        return a.GetDataObjID();
      })
    );

    // Remove sc nodes on the current page, including containers and their associates
    for (var i = 0; i < nodes.length; i++) {
      var theNode = nodes[i];
      var theObjID = theNode.GetDataObjID();
      if (theNode.GetLayout().GetContainerType() == enumContainerType.standardmrb) {
        var associatedIDs = theNode.GetLayout().GetAssociatedObjIDs(false);
        delete theNode.GetLayout().fAssociatedChildrenIDs;
        if (associatedIDs.length === 0 || !objIDSet.has(associatedIDs[0])) {
          if (!scm.RemoveSCNode(theObjID, scid)) failList.push(theNode);
        }
      } else {
        var theObj = theNode.GetDataObj();
        var subType = theNode.GetLayout()?.GetBoxSubType();
        if (theObj == null && subType !== enumBoxSubTypes.holderAreaBox) {
          //Shouldn't happen unless on a master page or something.
          continue;
        }
        //if (scLevel > curMax)
        if (true) {
          if (theNode.GetLayout().GetContainerObjID() != null) {
            //containers
            var containerID = theNode.GetLayout().GetContainerObjID();
            scm.RemoveSCNode(containerID, scid);
          }
          if (!scm.RemoveSCNode(theObjID, scid)) failList.push(theNode);
        }
      }
    }
    for (i = 0; i < failList.length; i++) {
      //Fallback because we can have a lot of SCnodes (more than 2) in the Viewer.
      //TODO: It would be superior to prevent too many nodes from being made in the first place.
      var badNode = failList[i];
      var index = scm.fNodeList.indexOf(badNode);
      if (index > -1) scm.fNodeList.splice(index, 1);
    }
  }

  UpdateLayout(curLayout, newLayout, dataObj, dataObjID) {
    newLayout.TransferBranchStyle(curLayout);
    newLayout.TransferMarginsAndSpacing(curLayout);
    newLayout.TransferGroupProps(curLayout);
    newLayout.TransferHighlightProps(curLayout);
    newLayout.TransferConnectingLineProps(curLayout);
    newLayout.CopyCentering(curLayout);
    newLayout.SetPosition(curLayout.GetPositionX(), curLayout.GetPositionY());
    newLayout.CopySubChartInfo(curLayout);
    newLayout.SetDBObj(dataObj);
    newLayout.SetDBObjID(dataObjID);
    newLayout.SetDocRef(curLayout.GetDocRef());
    newLayout.TransferOverrides(curLayout);
    if (
      curLayout.GetContainerType() !== enumContainerType.nonmrb &&
      newLayout.GetContainerType() !== enumContainerType.nonmrb
    )
      newLayout.SetAssociatedObjIDs(curLayout.GetAssociatedObjIDs());

    //newLayout.SetTableFieldRef(curLayout.GetTableFieldRef());

    curLayout.RestoreProperties(newLayout);

    this.IncChangeCount();
  }

  CopyNewDocCellRefs(curLayout, newLayout, dataObj) {
    var n2 = newLayout.fCellList.length;
    for (var i = 0; i < n2; i++) {
      var c = newLayout.fCellList[i];
      var fieldDef = c.GetField();
      if (fieldDef && dataObj) {
        //Make sure current version of field def is applied.
        var fieldID = fieldDef.GetFieldID();
        var curField = dataObj.GetFieldDefByID(fieldID);
        c.SetField(curField);
      }
    }
  }

  GetParentListForChart() {
    var parentList = [];
    var n = this.GetSCNodeCount();
    for (var i = 0; i < n; i++) {
      var scn = this.GetIndexSCNode(i); // fNodeList[i];
      var dbObj = scn.GetDataObj();
      if (dbObj && dbObj.GetNumChildren() > 0) {
        var curSCID = scn.GetSubChartID();
        var sc = this.FindSubChart(curSCID);
        if (!sc) continue;
        if (sc.IsInMainSubChart(dbObj)) parentList.push(dbObj);
      }
    }

    return parentList;
  }

  UpdateLayoutForEntireChart(newLayout, excludeSubChart) {
    var nodeList = [];
    var n = this.GetSCNodeCount();
    for (var i = 0; i < n; i++) {
      var scn = this.GetIndexSCNode(i); // fNodeList[i];
      var curID = scn.GetSubChartID();
      if (curID != excludeSubChart && curID != 0) {
        var sc = this.FindSubChart(curID);
        var dbObj = scn.GetDataObj();
        if (dbObj && sc.IsInMainSubChart(dbObj)) nodeList.push(scn);
      }
    }

    this.UpdateLayoutForSCNodes(newLayout, nodeList, null);
  }

  RecalcLayoutForEntireChart() {
    var n = this.GetSCNodeCount();
    for (var i = 0; i < n; i++) {
      var scn = this.GetIndexSCNode(i); // fNodeList[i];
      var curID = scn.GetSubChartID();
      if (curID != 0) {
        var aLayout = scn.GetLayout();
        aLayout.CalculateLayout();
      }
    }
  }

  UpdateLayoutForSCNodes(newLayout, scNodes, boxProps) {
    for (var i = 0; i < scNodes.length; i++) {
      var curNode = scNodes[i];
      var curLayout = curNode.GetLayout();

      if (boxProps) boxProps.ApplyBoxProps(curLayout);
      else {
        var dataObj = curNode.GetDataObj();
        var dataObjID = curNode.GetDataObjID();
        var cloneLayout = newLayout.Clone();
        this.UpdateLayout(curLayout, cloneLayout, dataObj, dataObjID);
      }
    }
  }

  UpdateName(subChart, newName) {
    subChart.SetSubChartName(newName);
    subChart.fOverrideField = true;
    this.SaveBreakInfo(subChart.GetTopDBObj(), "rename", newName);
    this.IncChangeCount();
  }

  PrepVal(value) {
    var matchCase = this.GetMatchCase();
    value = value.toString();
    if (!matchCase) value = value.toLowerCase();
    return value;
  }

  CreateSCNodeList(
    fieldDef,
    createIndex,
    includeTop //, fieldDef2
  ) {
    // Only used during refresh not an issue for undo/redo
    var scNodeList = null;

    if (!createIndex) scNodeList = [];
    else {
      var scNodeList = new QGenericIndex();
      scNodeList.InitIndex();
    }

    var n = this.GetSCNodeCount();
    for (var i = 0; i < n; i++) {
      var scn = this.GetIndexSCNode(i); // fNodeList[i];
      var curID = scn.GetSubChartID();
      if (curID != 0) {
        var sc = this.FindSubChart(curID);
        var dbObj = scn.GetDataObj();
        var topObj = null;

        // sc shouldn't ever be null - defensive code...
        if (sc && !includeTop) topObj = sc.GetTopDBObj();
        if (dbObj && dbObj != topObj && sc && sc.IsInMainSubChart(dbObj)) {
          if (createIndex) {
            var v1 = dbObj.GetFieldValue(fieldDef);
            var v2 = scn.GetSubChartFlag();

            if (v1 != null) {
              v1 = this.PrepVal(v1); // .toString().toLowerCase();
              v2 = this.PrepVal(v2); // v2.toString();
              if (v1.length > 0) {
                var v = v1 + "+" + v2;
                scNodeList.AddToIndex(scn, v);
              }
            }
          } else scNodeList.push(scn);
        }
      }
    }

    return scNodeList;
  }

  GetNonChartNodes(subChartID) {
    var nodeList = [];
    var n = this.fNonChartNodes.length;
    for (var i = 0; i < n; i++) {
      var scn = this.fNonChartNodes[i];
      var scID = scn.GetSubChartID();
      if (scID == subChartID) nodeList.push(scn);
    }

    return nodeList;
  }

  LoadLegacyBackgroundNodes() {
    var mpSC = this.GetMasterPageSubChart();
    var rootOrder = mpSC.GetRootOrderLoad();
    var mpList = null;

    if (rootOrder != null && rootOrder.length > 0) {
      var n = rootOrder.length;
      mpList = [];
      for (var i = 0; i < n; i++) {
        var dbID = rootOrder[i];
        var index = this.FindSCNodeIndex(dbID, kMasterSCID);
        var scNode = this.GetIndexSCNode(index, true);

        if (scNode == null) console.log("GetMasterPageSCNodeList - SCNode is Null!");
        else mpList.push(scNode);
      }
    } else {
      var scID = mpSC.GetSubChartID();
      mpList = this.GetNodesForSubChart(scID, false);
    }

    return mpList;
  }

  GetNodesForSubChart(subChartID, mainChartOnly) {
    // OptimizeSC
    // Fast path: use index if available and no mainChartOnly filtering needed
    if (this.fSCNodeIndex != null && !mainChartOnly) {
      var indexed = this.FindSCNodeList(subChartID);
      return indexed ? indexed.slice() : [];
    }

    var nodeList = [];
    var sc = null;

    var isBG = subChartID === 0;

    if (isBG) sc = this.GetMasterPageSubChart();
    else sc = this.FindSubChart(subChartID);

    var n = this.GetSCNodeCount(isBG);
    for (var i = 0; i < n; i++) {
      var scn = this.GetIndexSCNode(i, isBG); // fNodeList[i];
      var scID = scn.GetSubChartID();
      if (scID == subChartID) {
        var pushIt = true;
        if (mainChartOnly) {
          pushIt = false;
          var dbObj = scn.GetDataObj();
          if (dbObj && sc.IsInMainSubChart(dbObj)) pushIt = true;
        }

        if (pushIt) nodeList.push(scn);
      }
    }

    return nodeList;
  }

  GetUnfilteredNodesForSubChart(subChartID) {
    var totalNodes = this.GetNodesForSubChart(subChartID, false);
    var count = 0;
    for (var i = 0; i < totalNodes.length; i++) {
      var dataObj = totalNodes[i].GetDataObj();
      if (dataObj && !dataObj.IsFiltered()) count += 1;
    }
    return count;
  }

  GetNodesForSubChartBranch(curSC, theList) {
    var id = curSC.GetSubChartID();
    var nodeList = this.GetNodesForSubChart(id, false);
    theList.push.apply(theList, nodeList);

    var n = curSC.ChildCount();
    for (var i = 0; i < n; i++) {
      var sc = curSC.GetIndexChild(i);
      this.GetNodesForSubChartBranch(sc, theList);
    }
  }

  GetIndexSubChart(index) {
    return this.fSubChartList[index];
  }

  GetIndexOfSubChart(subChart) {
    return this.fSubChartList.indexOf(subChart);
  }

  RebuildSubChartList(topSC, newList) {
    newList.push(topSC);
    var n = topSC.ChildCount();
    for (var i = 0; i < n; i++) {
      var childSC = topSC.GetIndexChild(i);
      this.RebuildSubChartList(childSC, newList);
    }
  }

  SyncSubChartList() {
    var r = this.GetRootSubChart();
    var newList = [];
    this.RebuildSubChartList(r, newList);

    if (this.fSCMJournal) this.fSCMJournal.SubChartListChanged(this.fSubChartList);

    this.fSubChartList = newList;
  }

  GetChildren(subChart) {
    var id = subChart.GetSubChartID();
    var children = [];
    var n = subChart.ChildCount();
    for (var i = 0; i < n; i++) {
      var sc = subChart.GetIndexChild(i);
      children.push(sc);
    }

    return children;
  }

  GetSubChartBranch(subChart, theList) {
    theList.push(subChart);
    var n = subChart.ChildCount();
    for (var i = 0; i < n; i++) {
      var sc = subChart.GetIndexChild(i);
      this.GetSubChartBranch(sc, theList);
    }
  }

  GetChangeCount() {
    return this.fChangeCount;
  }

  UpdateSubChartID(
    newNode,
    origSubChartID,
    newSubChartID //, nodeIndex)
  ) {
    var layout = newNode.GetLayout();
    var subChartID = layout.GetSubChartID();
    if (subChartID == origSubChartID || subChartID == newSubChartID) {
      var dbObj = newNode.GetDataObj();
      layout.SetSubChartID(newSubChartID);
      if (!dbObj) return;
      var numChildren = dbObj.GetNumChildrenNoFilter();

      var matchContainers = [];
      for (var i = 0; i < numChildren; i++) {
        var childObj = dbObj.GetIndexChildNoFilter(i);
        var childObjID = childObj.GetObjectID();
        var childNode = null;

        if (childNode == null) {
          var childNodeIdx = this.FindSCNodeIndex(childObjID, origSubChartID);
          if (childNodeIdx != -1) childNode = this.GetIndexSCNode(childNodeIdx);
        }

        if (childNode) {
          if (childNode.IsPositionSCNode()) {
            var holderNodes = this.GetHolderNodesForPosition(childNode);
            for (var aHolderNode in holderNodes) {
              var theHolderNode = holderNodes[aHolderNode];
              var theHolderLayout = theHolderNode.GetLayout();
              if (theHolderLayout.GetSubChartID() === origSubChartID) {
                theHolderLayout.SetSubChartID(newSubChartID);
              }
            }
          }

          this.UpdateSubChartID(childNode, origSubChartID, newSubChartID); // , nodeIndex);
          var containerID = childNode.GetLayout().GetContainerObjID();
          if (containerID && !childNode.IsPositionSCNode()) {
            var container = this.FindSCNodeByID(containerID, origSubChartID);
            if (!container) {
              //should only happen during copylockedlayouts
              console.log("failed to find container- ok if copylockedlayouts");
              continue;
            }
            if (matchContainers.indexOf(container) == -1) matchContainers.push(container);
          }
        }
      }
      for (var aMatchContainer in matchContainers) {
        var theMatchContainer = matchContainers[aMatchContainer];
        this.UpdateSubChartID(theMatchContainer, origSubChartID, newSubChartID);
      }
    }
  }

  OptimizeAllSubcharts() {
    var curSubChart = this.GetCurrentSubChart();
    var n = this.GetNumSubCharts();
    for (var i = 0; i < n; i++) {
      var subchart = this.GetIndexSubChart(i);
      if (subchart != curSubChart) subchart.SetNeedOptimize(true);
    }
  }

  OptimizeSubchart2(
    subChartID //, subChartRules)
  ) {
    var curSubChart = this.GetCurrentSubChart();
    var curID = curSubChart.GetSubChartID();
    var isServerChart = this.GetDoc().IsServerChart(); //TODO: Serverchart isn't really the right question here.
    if (curID == subChartID || isServerChart) {
      var pageLayoutMgr = this.fPageLayoutMgr;
      var rootNodes = [];
      pageLayoutMgr.GetRootNodes(rootNodes, true);

      var curDoc = this.GetDoc();
      DoOptimizeHelper(rootNodes[0], pageLayoutMgr, curDoc);
    } else {
      var aSubChart = this.FindSubChart(subChartID);
      aSubChart.SetNeedOptimize(true);
    }
  }

  UpdateBranchStyleChildLevel(scNodes) {
    var scNodeCount = scNodes.length;
    var bStyle = enumBranchStyle.onecolumnright;
    if (scNodeCount > 200) bStyle = enumBranchStyle.twentycolumn;
    else if (scNodeCount > 144) bStyle = enumBranchStyle.sixteencolumn;
    else if (scNodeCount > 96) bStyle = enumBranchStyle.twelvecolumn;
    else if (scNodeCount > 48) bStyle = enumBranchStyle.eightcolumn;
    else if (scNodeCount > 36) bStyle = enumBranchStyle.sixcolumn;
    else if (scNodeCount > 24) bStyle = enumBranchStyle.fourcolumn;
    else if (scNodeCount > 12) bStyle = enumBranchStyle.twocolumn;

    for (var i = 0; i < scNodeCount; i++) {
      var childNode = scNodes[i];
      if (!childNode.IsAssistant()) childNode.SetBranchStyle(bStyle);
    }
  }

  UpdateBranchRemoveSCBreak(topNode) {
    var subChartID = topNode.GetSubChartID();
    var dbObj = topNode.GetDataObj();
    var numChildren = dbObj.GetNumChildren();

    var scNodes = this.GetNodesForSubChart(subChartID, true);
    var scNodeCount = scNodes.length;
    if (numChildren === scNodeCount - 1) {
      this.UpdateBranchStyleChildLevel(scNodes);
      //forceOptimize = false;
    } else if (scNodeCount < 8) {
      var bStyle = enumBranchStyle.onecolumnright;
      for (var i = 0; i < numChildren; i++) {
        var childObj = dbObj.GetIndexChild(i);
        var childNode = this.FindSCNode(childObj, subChartID);
        if (childNode && !childNode.IsAssistant()) childNode.SetBranchStyle(bStyle);
      }
      //forceOptimize = false;
    }

    //return forceOptimize || overrideOptimize;
  }

  AddSubChartObj(theID, parentID, topDBObj, subChartName, fieldID) {
    if (this.fSCMJournal) this.fSCMJournal.SubChartListChanged(this.fSubChartList);

    var subChart = new QSubChart();
    var parentSC = this.FindSubChart(parentID);
    subChart.InitSubChart(theID, parentSC, topDBObj, subChartName, fieldID, this);
    this.fSubChartList.push(subChart);

    return subChart;
  }

  SetNameUsingID(fieldID) {
    // JournalSC??
    this.fDefNameID = fieldID;
  }

  GetNameUsingID() {
    return this.fDefNameID;
  }

  SetSubChartSort(scSort) {
    this.fSCSort = scSort;
  }

  GetSubChartSort() {
    return this.fSCSort;
  }

  SortByTopObj(subChart, sortKey) {
    var childList = subChart.fChildren;
    if (!sortKey) return childList;
    childList.sort(function (child1, child2) {
      let childValue1 = child1.GetTopObjField(sortKey);
      let childValue2 = child2.GetTopObjField(sortKey);

      // Null check
      if (childValue1 == null) childValue1 = "";
      if (childValue2 == null) childValue2 = "";

      // Numeric Comparisons
      if (typeof childValue1 === "number" && typeof childValue2 === "number") {
        return childValue1 - childValue2;
      }

      if (!childValue1?.localeCompare) {
        childValue1 = childValue1.toString();
        childValue2 = childValue2.toString();
      }

      return childValue1.localeCompare(childValue2);
    });
    return childList;
  }

  SortSubCharts() {
    var scSort = this.GetSubChartSort();
    if (!scSort || !scSort["enabled"]) return;
    var scSortKey = scSort["sortKey"];
    var scCount = this.GetNumSubCharts();
    for (var i = 0; i < scCount; i++) {
      var curSC = this.GetIndexSubChart(i);
      curSC.fChildren = this.SortByTopObj(curSC, scSortKey);
    }
  }

  AddSubChart(theID, parentID, topDBObj, subChartName) {
    var existingSC = this.FindSubChart(theID);
    var newSubChart = existingSC;
    if (existingSC == null) {
      newSubChart = this.AddSubChartObj(
        theID,
        parentID,
        topDBObj,
        subChartName,
        this.GetNameUsingID()
      );

      var parentSC = this.FindSubChart(parentID);
      if (parentSC) {
        var childList = [];
        var n = parentSC.ChildCount();
        for (var i = 0; i < n; i++) {
          var child = parentSC.GetIndexChild(i);
          childList.push(child);
        }

        for (var i = 0; i < n; i++) {
          var child = childList[i];
          var topObjID = child.GetTopDBObjID();
          var childSubChartID = child.GetSubChartID();
          var index = this.FindSCSubNodeIndex(topObjID, childSubChartID);
          if (index === -1) {
            // RemoveAllSubChartBreaks intentionally leaves drillup-flagged breaks in place
            // (QSubChartMgr.js RemoveAllSubChartBreaks), so a child's connecting box can
            // legitimately still be exactly where this child subchart already records it --
            // never relocated by this recompute. Confirm that with an exact-match lookup
            // before treating it as a no-op; if the box isn't there either, this is an
            // unexplained state and must fail loudly rather than be silently absorbed.
            if (this.FindSCNodeIndex(topObjID, childSubChartID) === -1) {
              throw new Error(
                `AddSubChart: no SC node found for child subchart's top object ${topObjID} ` +
                  `(childSubChartID=${childSubChartID}, parentID=${parentID}, theID=${theID})`
              );
            }
            continue;
          }
          var parentNode = this.GetIndexSCNode(index);
          var layout = parentNode.GetLayout();
          var scID = layout.GetSubChartID();
          if (scID != parentID && child != newSubChart) {
            parentSC.RemoveChild(child);
            newSubChart.AddChildSubChart(child);
            child.SetParent(newSubChart);
          }
        }
      }
    }
    return newSubChart;
  }

  RemoveSubChart(theID) {
    // JournalSC
    var existingSC = this.FindSubChart(theID);
    if (existingSC) {
      var p = existingSC.GetSubChartParent();
      var i = this.FindSubChartIndex(theID);
      if (i != -1) {
        if (this.fSCMJournal) this.fSCMJournal.SubChartListChanged(this.fSubChartList);
        this.fSubChartList.splice(i, 1);
        this._subChartMap = null;
      }

      var n = existingSC.ChildCount();
      var childList = [];
      for (var i = 0; i < n; i++) {
        var s = existingSC.GetIndexChild(i);
        childList.push(s);
      }
      if (p) {
        existingSC.DonateChildren(p);
        p.RemoveChild(existingSC);
      }
    }
  }

  GetDeptBreakList(obj, breakField, smartBreak, smartStart, breakList) {
    var numChildren = obj.GetNumChildren();
    if (numChildren == 0) return;

    var level = obj.DoLevelCalc();
    var insertBreak = false;
    if (level == smartStart) insertBreak = true;
    else if (level > smartStart) {
      var dept = obj.GetFieldValue(breakField);
      var parentObj = obj.GetParent();
      var parentDept = null;
      if (parentObj != null) parentDept = parentObj.GetFieldValue(breakField);

      if (parentDept != null) {
        var a = "";
        if (dept) a = this.PrepVal(dept); // .toLowerCase();
        var b = "";
        if (parentDept) b = this.PrepVal(parentDept); // .toLowerCase();
        if (a != b) insertBreak = true; // this.CheckSmartBreak(obj,smartBreak,level,smartStart);
      }
    }

    if (insertBreak) {
      OutputSCName("Tagging for break:", obj);
      var targetNode = this.FindSCNode(obj, 1);
      breakList.push(targetNode);
    }

    var numChildren = obj.GetNumChildren();
    for (var i = 0; i < numChildren; i++) {
      var child = obj.GetIndexChild(i);
      this.GetDeptBreakList(child, breakField, smartBreak, smartStart, breakList);
    }
  }

  GetLevelBreakList(obj, levelBreak, smartStart, breakList, smartBreak) {
    var numChildren = obj.GetNumChildren();
    if (numChildren == 0) return;

    var level = obj.DoLevelCalc();
    var insertBreak = false;
    if (level == smartStart) insertBreak = true;
    else if (level > smartStart) {
      var breakCalc = (level - smartStart) % (levelBreak - 1);
      insertBreak = breakCalc == 0;
    }

    if (insertBreak) {
      // Check to see if there is only one node in the previous subchart - if so don't insert a break
      var parentObj = obj.GetParent();
      var bIndex = breakList.length - 1;
      if (parentObj && bIndex >= 0) {
        var numParentChildren = parentObj.GetNumChildren();
        if (numParentChildren == 1) {
          var lastNode = breakList[bIndex];
          var lastObj = lastNode.GetDataObj();
          if (lastObj == parentObj && (smartBreak == null || smartBreak > 1)) insertBreak = false;
        }
      }

      if (insertBreak) {
        var targetNode = this.FindSCNode(obj, 1);
        if (!targetNode) {
          var targetNodeIdx = this.FindSCSubNodeIndex(obj.GetObjectID(), 1);
          if (targetNodeIdx > -1) targetNode = this.GetIndexSCNode(targetNodeIdx);
        }
        if (targetNode) breakList.push(targetNode);
      }
    }

    for (var i = 0; i < numChildren; i++) {
      var child = obj.GetIndexChild(i);
      this.GetLevelBreakList(child, levelBreak, smartStart, breakList, smartBreak);
    }
  }

  HasBreakOverrides() {
    const overrides = this.fManualPaginationDeltas ?? [];
    return overrides.some(override => ["insert", "remove"].includes(override.fType));
  }

  ClearBreakOverrides() {
    const overrides = this.fManualPaginationDeltas ?? [];
    this.fManualPaginationDeltas = overrides.filter(override => {
      return !["insert", "remove"].includes(override.fType);
    });
  }

  DoInsertSubChartBreak(scNode, smartBreak, smartStart, optimizeLayout) {
    var targetLayout = scNode.GetLayout();
    var dataObj = scNode.GetDataObj();
    var dataObjID = scNode.GetDataObjID();
    var curLevel = dataObj.DoLevelCalc();

    var numSubs = dataObj.CountSubs();
    if (numSubs == 0) return null;

    if (smartBreak != null && numSubs < smartBreak && curLevel > smartStart) return null;

    // A grouped box that still heads its own subtree (a manager included in a group) is a
    // legitimate page-break target: it stays in its group on the current page while its
    // subordinates drill to a new subchart. Childless grouped boxes already returned above
    // via the numSubs == 0 guard, so only the container box itself blocks a break here.
    var isContainerBox = targetLayout.GetContainerType() != enumContainerType.nonmrb;

    if (isContainerBox && !scNode.IsPositionSCNode()) return null;

    var newSubchart = this.InsertSubChartBreak(targetLayout, dataObj, dataObjID, optimizeLayout);
    return newSubchart;
  }

  InsertBreaks(breakList, smartBreak, smartStart, autoBreak, optimizePage) {
    var n = breakList.length;
    if (n == 0) return;

    this.SortNodes();
    // Process every entry. A break target whose SCNode could not be resolved (e.g. a
    // grouped node) is pushed as null/invalid by the break-list builders; skip those
    // rather than letting a single bad entry abort the loop and silently drop all
    // remaining valid breaks.
    while (breakList.length > 0) {
      var nextBreak = breakList.pop();
      if (!nextBreak || typeof nextBreak.GetDataObj !== "function") continue;
      var topObj = nextBreak.GetDataObj();
      OutputSCName("Inserting Std Break:", topObj);
      this.DoInsertSubChartBreak(nextBreak, smartBreak, smartStart, optimizePage);
    }
    // this.fNodesSorted = false;
  }

  DoSmartBreaks(subchartRules, scOption) {
    var smartStart = subchartRules.GetSmartStartVal();

    var baseSC = this.GetIndexSubChart(0);
    var topObj = baseSC.GetTopDBObj();
    var breakList = [];
    if (scOption == enumSubChartOption.breakbylevel) {
      var levelBreak = subchartRules.GetBreakLevelsVal();
      var smartBreak = subchartRules.GetSmartBreakVal();
      this.GetLevelBreakList(topObj, levelBreak, smartStart, breakList, smartBreak);
    } else if (scOption == enumSubChartOption.autobreaks) {
      var pageDensity = subchartRules.GetPageDensity();
      GetSmartBreakList(topObj, pageDensity, smartStart, breakList, this);
    }
    this.DoInsertBreaks(breakList, subchartRules);
  }

  DoInsertBreaks(breakList, subchartRules) {
    var smartBreak = subchartRules.GetSmartBreakVal();
    var smartStart = subchartRules.GetSmartStartVal();
    // var autoBreak = subchartRules.GetAutoBreakOption();
    var autoBreak = false;
    this.InsertBreaks(breakList, smartBreak, smartStart, autoBreak, true);
  }

  DoInsertOrphanBreaks(topOrphanObj, subchartRules, scOption) {
    var smartStart = subchartRules.GetSmartStartVal();
    smartStart -= 1;
    //var baseSC = this.GetIndexSubChart(0);
    var topObj = topOrphanObj;
    var breakList = [];
    if (scOption == enumSubChartOption.breakbylevel) {
      var levelBreak = subchartRules.GetBreakLevelsVal();
      var smartBreak = subchartRules.GetSmartBreakVal();
      this.GetLevelBreakList(topObj, levelBreak, smartStart, breakList, smartBreak);
    } else if (scOption == enumSubChartOption.autobreaks) {
      var pageDensity = subchartRules.GetPageDensity();
      GetSmartBreakList(topObj, pageDensity, smartStart, breakList, this);
    }
    //breakList.reverse();
    this.DoInsertBreaks(breakList, subchartRules);
  }

  BreakUpDept(curSC, curSize, candidates, largeSOC) {
    var done = false;
    var n = candidates.length;
    var i = 0;
    var newSize = curSize;
    var scID = curSC.GetSubChartID();
    var subList = [];

    while (!done) {
      var c = candidates[i];
      var scNode = this.FindSCNode(c.fObj, scID);
      var newSC = this.DoInsertSubChartBreak(scNode, null, null, true);
      subList.push(newSC);

      newSize = newSize - c.fSubCount;
      i++;

      if (largeSOC) done = i == n;
      else done = i == n || newSize < kMaxSCSize;
    }

    this.HandleLargeDepts(subList);
    if (curSize != newSize) this.OptimizeSubchart2(scID);
  }

  CountSubsInSubChart(topObj, subChart, directsOnly) {
    if (topObj == null) topObj = subChart.GetTopDBObj();
    var subChartID = subChart.GetSubChartID();
    var scNode = this.FindSCNode(topObj, subChartID);
    if (scNode == null) return 0;

    var layout = scNode.GetLayout();
    var scFlag = layout.GetSubChartFlag();
    var isBottom = scFlag == enumSubChartFlag.drilldown;
    var scSize = topObj.CountSubsInSubChart(isBottom, directsOnly);
    return scSize;
  }

  AnalyzeDepts(sc, minSubCount) {
    var topObj = sc.GetTopDBObj();
    var subChartID = sc.GetSubChartID();
    var candidates = [];
    var numChildren = topObj.GetNumChildren();
    for (var j = 0; j < numChildren; j++) {
      var c = topObj.GetIndexChild(j);
      var subCount = this.CountSubsInSubChart(c, sc, false);
      if (subCount > minSubCount) {
        var candidate = new QSCCandidate();
        candidate.fObj = c;
        candidate.fSubCount = subCount;
        candidates.push(candidate);
      }
    }

    if (candidates.length > 0)
      candidates.sort(function (a, b) {
        return b.fSubCount - a.fSubCount;
      });

    return candidates;
  }

  HandleLargeDepts(scList) {
    var n = scList.length;
    for (var i = 0; i < n; i++) {
      var sc = scList[i];
      var scSize = this.CountSubsInSubChart(null, sc, false);
      var soc = this.CountSubsInSubChart(null, sc, true);
      var largeSOC = soc > kMaxSpanOfControl;
      var minSubCount = 1;
      if (scSize >= kMaxSCSize || largeSOC) {
        var candidates = this.AnalyzeDepts(sc, minSubCount);
        if (candidates.length > 0) this.BreakUpDept(sc, scSize, candidates, largeSOC);
      }
    }
  }

  DoBreakByDept(subchartRules) {
    var baseSC = this.GetIndexSubChart(0);
    var topObj = baseSC.GetTopDBObj();
    var deptBreakField = subchartRules.GetBreakField();

    var objDB = this.GetObjDB();
    var boxClass = objDB.GetClassByName("Box");
    var breakField = boxClass.GetFieldDefByName(deptBreakField);
    if (breakField == null) return;

    var smartBreak = subchartRules.GetSmartBreakVal();
    var smartStart = subchartRules.GetSmartStartVal();
    //    var autoBreak = subchartRules.GetAutoBreakOption();

    var breakList = [];
    this.GetDeptBreakList(topObj, breakField, smartBreak, smartStart, breakList);
    this.DoInsertBreaks(breakList, subchartRules);

    var scList = this.fSubChartList.slice(0);
    this.HandleLargeDepts(scList);
    //	this.InsertBreaks(breakList,smartBreak,smartStart,autoBreak,true);
    //	this.OptimizeTopSubchart(); //subchartRules
  }

  RenameAllSubCharts(subchartRules) {
    var nameUsingID = subchartRules.GetSubChartNameFieldID();
    var n = this.GetNumSubCharts();
    for (var i = 0; i < n; i++) {
      var sc = this.GetIndexSubChart(i);
      sc.SetSubChartFieldID(nameUsingID);
    }
    this.SetNameUsingID(nameUsingID);
  }

  OptimizeTopSubchart() {
    //subChartRules
    //
    var baseSC = this.GetIndexSubChart(0);
    var scID = baseSC.GetSubChartID();
    this.OptimizeSubchart2(scID); //subChartRules);
  }

  GetRecordIDField(boxClass) {
    // If the PersonID doesn't exist then the Name and PersonID are the same fielddef...
    var IDfieldDef = boxClass.GetRecordIDFieldDef(true);

    return IDfieldDef;
  }

  GetTitleField(boxClass) {
    var IDfieldDef = boxClass.GetTitleFieldDef(true);

    return IDfieldDef;
  }

  GetNameField(boxClass) {
    var nameFieldDef = GetNameDefForClass(boxClass); // boxClass.GetFieldDefByID("Name");
    return nameFieldDef;
  }

  GetSCBreakTops() {
    var theList = [];
    var n = this.GetNumSubCharts();
    // var scRootID = this.GetRootSubChartID();

    for (var i = 0; i < n; i++) {
      var sc = this.fSubChartList[i];
      //   var scID = sc.GetSubChartID();
      var needOpt = sc.GetNeedOptimize();
      var subchartName = null;
      if (sc.OverrideSubChartName()) subchartName = sc.GetSubChartName();
      var topObj = sc.GetTopDBObj();
      topObj["subchartName"] = subchartName;
      topObj["needOpt"] = needOpt;
      theList.push(topObj);
    }

    return theList;
  }

  TrimDocument() {
    var n = this.GetSCNodeCount();
    for (var i = 0; i < n; i++) {
      var scn = this.GetIndexSCNode(i); // fNodeList[i];
      var layout = scn.GetLayout();
      if (scn.GetSubChartID() != 0) layout.TrimLayout();
    }
  }

  DoCopyFloatingElements() {}

  GetPriorDoc(subchartRules) {
    var pDocMgr = subchartRules.GetPriorDocMgr();
    if (pDocMgr == null) return null;

    var curDoc = this.GetDoc();

    var divName = curDoc.GetDivisionName();
    var priorDoc = null;
    if (divName != null) {
      // Current Doc is a multi-doc
      // Must find a matching division in prior
      priorDoc = pDocMgr.GetDocByDivName(divName);
      if (priorDoc == null) return null;
    } else {
      // Current Doc is single doc
      // Only return priorDoc if single also
      priorDoc = pDocMgr.GetIndexDoc(0);
      var priorDivName = priorDoc.GetDivisionName();
      if (priorDivName != null) priorDoc = null;
    }

    return priorDoc;
  }

  // SD1118
  DiagnosticLog(action, type, info) {
    if (!Globals._refreshDiagnostic) return;

    var theDoc = this.GetDoc();
    var divName = theDoc.GetDivisionName();
    if (divName == null) divName = "OrgChart";

    var r = [divName, action, type, info];

    Globals._refreshDiagnostic.AddDataRow(r);
  }

  HandleManualName(nodeList, theBreak) {
    nodeList.sort((aNode, bNode) => {
      if (aNode.IsTopOfSubChart()) {
        return -1;
      }

      if (bNode.IsTopOfSubChart()) {
        return 1;
      }

      return 0;
    });

    for (var aSCNodeIdx in nodeList) {
      var theNode = nodeList[aSCNodeIdx];
      var theDataObj = theNode.GetDataObj();
      var nameDef = theDataObj.GetFieldDefByID("Name");
      if (!nameDef) nameDef = theDataObj.GetFieldDefByID("PersonID");
      if (theBreak.GetBreakType() == "rename") {
        var theSubChartID = theNode.GetSubChartID();
        //TODO: This should be a generic function already?
        var theSubChart = this.FindSubChart(theSubChartID);
        var theName = theBreak.fName;
        if (theSubChart && theName) {
          this.DiagnosticLog(
            "Subchart Break",
            "Rename",
            "User renamed Subchart '" + theSubChart.GetSubChartName() + "' to '" + theName + "'"
          );
          this.UpdateName(theSubChart, theName);
          return true;
        }
      }
    }
    return false;
  }

  HandleManualBreak(nodeList, theBreak) {
    //return value is for if it is handled, not weather it is applied.
    for (var aSCNodeIdx in nodeList) {
      var theNode = nodeList[aSCNodeIdx];
      var theDataObj = theNode.GetDataObj();
      var nameDef = theDataObj.GetFieldDefByID("Name");
      if (!nameDef) nameDef = theDataObj.GetFieldDefByID("PersonID");
      var theLayout = theNode.GetLayout();
      //We found a subchart node matching the break point
      //TODO - scanning for the layout's subchart flag feels like a weird way to check states??
      switch (theBreak.GetBreakType()) {
        case "remove":
          if (theLayout.fSubChartFlag === enumSubChartFlag.drilldown) {
            if (
              (theBreak.fChildren.length < 5 && theDataObj.fChildren.length > 8) ||
              (theBreak.fChildren.length < 9 && theDataObj.fChildren.length > 16)
            ) {
              //Conditions to not do so: span if control gets blown out.
              this.DiagnosticLog(
                "Subchart Break",
                "Remove",
                "User break ingored: Span of control change: " +
                  theBreak.fChildren.length.toString() +
                  " to: " +
                  theDataObj.fChildren.length.toString() +
                  " for: " +
                  theDataObj.GetFieldValue(nameDef)
              );
            } else {
              this.RemoveSubChartBreak(theLayout, theDataObj, theNode.GetDataObjID(), false);
              this.RestoreBreakInfo(theBreak);
              this.DiagnosticLog(
                "Subchart Break",
                "Remove",
                "User removed break under '" + theDataObj.GetFieldValue(nameDef) + "'"
              );
            }
            return true;
          }
          break;
        case "insert":
          if (theLayout.fSubChartFlag === enumSubChartFlag.nobreak) {
            if (!theDataObj.fChildren || theDataObj.fChildren.length < 1) {
              //1. We don't have any more children, so there isn't anything to break on.
              //Check if children moved to some other parent and try to break them there?
              this.DiagnosticLog(
                "Subchart Break",
                "Insert",
                "User break ignored: " +
                  theBreak.fChildren.length.toString() +
                  " to: 0" +
                  " for: " +
                  theDataObj.GetFieldValue(nameDef)
              );
            } else {
              this.InsertSubChartBreak(theLayout, theDataObj, theNode.GetDataObjID(), false);
              this.RestoreBreakInfo(theBreak);

              this.DiagnosticLog(
                "Subchart Break",
                "Insert",
                "User inserted break under '" + theDataObj.GetFieldValue(nameDef) + "'"
              );
            }
            return true;
          } else if (theLayout.fSubChartFlag == enumSubChartFlag.drillup) {
            this.DiagnosticLog(
              "Subchart Break",
              "Insert",
              "User break ignored under '" +
                theDataObj.GetFieldValue(nameDef) +
                "' - Break already exists"
            );
            return true;
          }
          break;
      }
    }
    return false;
  }

  FindNewBreakParent(theBreak, fieldDef) {
    //We didn't find the topbox in the generated list, so look for children instead
    var parentMatches = {};
    for (var aSCNodeIdx in this.GetSCNodeList()) {
      //EDIT The manual pagination breaks?
      var theNode = this.GetSCNodeList()[aSCNodeIdx];
      var theDataObj = theNode.GetDataObj();
      var thePersonID = String(theDataObj.GetFieldValue(fieldDef));
      if (theBreak.fChildren.indexOf(thePersonID) > -1) {
        var theParent = theDataObj.GetParent();
        if (theParent) {
          var theParentID = String(theParent.GetFieldValue(fieldDef));
          if (parentMatches[theParentID]) {
            parentMatches[theParentID]++;
          } else parentMatches[theParentID] = 1;
        }
      }
    }
    for (var aParentID in parentMatches) {
      var numMatches = parentMatches[aParentID];
      if (numMatches > Math.floor(theBreak.fChildren.length / 2)) return aParentID;
    }
    return null;
  }

  DoSmartCopyBreaks(breaksToApply, priorDoc) {
    this.fManualPaginationDeltas = []; //This signifies that we've turned on the new system...

    var objDB = priorDoc.GetObjDB();
    var boxClass = objDB.GetClassByName("Box");
    var fieldDef = this.GetRecordIDField(boxClass);

    for (var aBreak in breaksToApply) {
      var theBreak = breaksToApply[aBreak];
      var theBreakTop = theBreak.GetBreakParent();
      var thePossibleNodes = this.FindSCSubNodesFromPersonID(theBreakTop);
      var handled = this.HandleManualBreak(thePossibleNodes, theBreak);
      if (!handled) {
        var newParent = this.FindNewBreakParent(theBreak, fieldDef);
        if (newParent) {
          var theBreakLabel =
            theBreak.GetBreakType().charAt(0).toUpperCase() + theBreakTop.slice(1);
          this.DiagnosticLog(
            "Subchart Break",
            theBreakLabel,
            "Manager not found (ID = '" + theBreakTop + "') Attempting to find replacement."
          );
          theBreak.fParent = newParent;
          thePossibleNodes = this.FindSCSubNodesFromPersonID(newParent);
          handled = this.HandleManualBreak(thePossibleNodes, theBreak);
          if (!handled)
            this.DiagnosticLog(
              "Subchart Break",
              theBreakLabel,
              "Unable to find replacement manager. Break not inserted."
            );
        }
      }
    }
  }

  DoSmartCopyNames(breaksToApply, priorDoc) {
    var objDB = priorDoc.GetObjDB();
    var boxClass = objDB.GetClassByName("Box");
    var fieldDef = this.GetRecordIDField(boxClass);
    for (var aBreak in breaksToApply) {
      var theBreak = breaksToApply[aBreak];
      var theBreakTop = theBreak.GetBreakParent();
      var thePossibleNodes = this.FindSCSubNodesFromPersonID(theBreakTop);
      var handled = this.HandleManualName(thePossibleNodes, theBreak);
      if (!handled) {
        var newParent = this.FindNewBreakParent(theBreak, fieldDef);
        if (newParent) {
          var theBreakLabel =
            theBreak.GetBreakType().charAt(0).toUpperCase() + theBreakTop.slice(1);
          this.DiagnosticLog(
            "Subchart Break",
            theBreakLabel,
            "Manager not found (ID = '" + theBreakTop + "') Attempting to find replacement."
          );
          theBreak.fParent = newParent;
          thePossibleNodes = this.FindSCSubNodesFromPersonID(newParent);
          handled = this.HandleManualBreak(thePossibleNodes, theBreak);
          if (!handled)
            this.DiagnosticLog(
              "Subchart Break",
              theBreakLabel,
              "Unable to find replacement manager. Break not inserted."
            );
        }
      }
    }
  }

  // SD1118
  DoAutoBreaks(subchartRules, forceRules) {
    var overflow = false;
    var doc = this.GetDoc();

    var thePriorDoc = this.GetPriorDoc(subchartRules);
    var doRename = subchartRules.GetRenameSubChartsFlag();
    if (doRename) {
      this.RenameAllSubCharts(subchartRules);
      subchartRules.SetRenameSubChartsFlag(false);
      return overflow;
    } else {
      this.RemoveAllSubChartBreaks(false);
      var baseSC = this.GetIndexSubChart(0);
      var nameUsingID = subchartRules.GetSubChartNameFieldID();
      baseSC.SetSubChartFieldID(nameUsingID);
      this.SetNameUsingID(nameUsingID);
    }

    /*
    var copyBreaks = false;
    var persistBS = false;
    if (!forceRules)
    {
        copyBreaks = subchartRules.GetPersistSCBreak();
        persistBS = subchartRules.GetPersistBranchStyle();
    }*/

    var forceSubCharts = false;
    var scOption = subchartRules.GetSubChartOption();
    if (forceSubCharts) scOption = enumSubChartOption.breakbylevel;

    switch (scOption) {
      case enumSubChartOption.nobreak:
        //this.WireSubChartList(subchartRules);
        break;
      case enumSubChartOption.autobreaks:
      case enumSubChartOption.breakbylevel:
        this.DoSmartBreaks(subchartRules, scOption); // null);
        break;
      case enumSubChartOption.breakbyfield:
        this.DoBreakByDept(subchartRules);
        break;
      default:
        break;
    }

    if (thePriorDoc && thePriorDoc.GetSubChartMgr())
      this.CopySubChartOrder(thePriorDoc.GetSubChartMgr());
  }

  CopySubChartNames(priorDoc) {
    const priorScm = priorDoc.GetSubChartMgr();
    const deltas = priorScm.fManualPaginationDeltas;

    const renameDeltas = deltas.filter(aDelta => {
      return aDelta.GetBreakType() === "rename";
    });

    if (renameDeltas === 0) return;

    this.DoSmartCopyNames(renameDeltas, priorDoc);
  }

  CopySubChartBreaks(subchartRules) {
    var overflow = false;
    var thePriorDoc = this.GetPriorDoc(subchartRules);
    var copyBreaks = true;
    var persistBS = subchartRules.GetPersistBranchStyle();

    if (thePriorDoc) {
      // DoingSmartRefresh(refreshHow))
      var manualDeltas = thePriorDoc.GetSubChartMgr().fManualPaginationDeltas;
      var renames = manualDeltas.filter(function (aDelta) {
        return aDelta.GetBreakType() === "rename";
      });
      var manualRenames = manualDeltas.filter(function (aDelta) {
        if (aDelta.GetBreakType() === "rename") {
          return aDelta;
        }
      });
      if (copyBreaks) {
        if (manualDeltas) this.DoSmartCopyBreaks(manualDeltas, thePriorDoc);
      }
      var nodeList = this.GetNodesForSubChart(1, true);
      if (renames) {
        this.DoSmartCopyNames(manualRenames, thePriorDoc);
      }
      if (nodeList.length < 500) {
        if (!persistBS) this.OptimizeTopSubchart(); //subchartRules
      } else {
        overflow = true;
        this.RemoveAllSubChartBreaks(false);
      }
    }

    return overflow;
  }

  CopySubChartOrder(priorSubCharMgr) {
    //adpCustomHeaders.map(function(a){return a['headerName']});
    this.DiagnosticLog("Subchart Order", "Sort", "Attempting to enforce prior sort order.");

    var priorSubChartList = priorSubCharMgr.fSubChartList;
    var curSubChartList = this.fSubChartList;
    try {
      var priorTopIDsList = priorSubChartList.map(function (a) {
        return a.fTopDBObj.GetObjectRecordID().toString();
      });
      var curTopIDsList = curSubChartList.map(function (a) {
        return a.fTopDBObj.GetObjectRecordID().toString();
      });
    } catch (error) {
      console.log("Failed to copy subchart order- unset person IDs");
      this.DiagnosticLog(
        "Subchart Order",
        "Sort",
        "Failed to copy subchart order- unset person IDs."
      );
      return;
    }

    for (var aCurSubChartIdx in curSubChartList) {
      var theSubChart = curSubChartList[aCurSubChartIdx];
      var theChildren = theSubChart.fChildren;
      var curChildrenIds = theChildren.map(function (a) {
        return a.fTopDBObj.GetObjectRecordID().toString();
      });
      if (priorTopIDsList.indexOf(curTopIDsList[aCurSubChartIdx]) > -1 && theChildren.length > 1) {
        //We had a subchart before so try to copy the order of the children...
        var orderedChildrenList = [];
        var orderedChildrenIDList = [];
        var thePriorSubChart =
          priorSubChartList[priorTopIDsList.indexOf(curTopIDsList[aCurSubChartIdx])];
        var priorChildrenIds = thePriorSubChart.fChildren.map(function (a) {
          return a.fTopDBObj.GetObjectRecordID().toString();
        });
        if (priorChildrenIds.indexOf(curTopIDsList[aCurSubChartIdx]) > -1) {
          var theInvalidSubChartID = curTopIDsList.indexOf(curTopIDsList[aCurSubChartIdx]);
          var theValidSubChartList = priorTopIDsList.slice();
          theValidSubChartList.splice(theInvalidSubChartID, 1);
          var theValidSubChartIdx =
            theValidSubChartList.indexOf(priorTopIDsList[aCurSubChartIdx]) +
            theInvalidSubChartID +
            1;
          thePriorSubChart = priorSubChartList[theValidSubChartIdx];
          priorChildrenIds = thePriorSubChart.fChildren.map(function (a) {
            return a.fTopDBObj.GetObjectRecordID().toString();
          });
        }

        for (var aPriorChildIdx in priorChildrenIds) {
          //Check to see if the child exists in the current subchart list...
          var thePriorChildID = priorChildrenIds[aPriorChildIdx];
          if (curChildrenIds.indexOf(thePriorChildID) > -1) {
            //We know we have as a valid, current child the old child...
            var theNewSubChartObj = curSubChartList[curTopIDsList.indexOf(thePriorChildID)];
            //TODO: JUST POP FROM THE OLD ARRAY AS YOU PUT THEM IN ORDER, THEN THE FINAL LOOP JUST PUSHES REMAINING SUBCHARTS
            orderedChildrenList.push(theNewSubChartObj);
            orderedChildrenIDList.push(thePriorChildID);
            theChildren.splice(curChildrenIds.indexOf(thePriorChildID), 1);
            curChildrenIds.splice(curChildrenIds.indexOf(thePriorChildID), 1);
          }
        }
        theSubChart.fChildren = orderedChildrenList.concat(theChildren);
      }
    }
    this.SyncSubChartList();
  }

  IsTopOfSubChart(dbObjID) {
    var sc = this.GetCurrentSubChart();
    if (
      sc.fDataObjArr &&
      sc.fDataObjArr
        .map(function (a) {
          return a.GetObjectID();
        })
        .indexOf(dbObjID) > -1
    )
      return true;
    return dbObjID == sc.GetTopDBObjID();
  }

  IsInMainSubChart(dbObj) {
    var sc = this.GetCurrentSubChart();
    return sc.IsInMainSubChart(dbObj);
  }

  //=================================================================================================
  //Insert & Remove
  ClipboardInsertSubChartBreak(topSCNode, bottomSCNode) {
    var nextSubChartID = this.GetNextUID();

    var topLayout = topSCNode.GetLayout();
    var topSubChartID = topSCNode.GetSubChartID();
    var dataObj = topSCNode.GetDataObj();

    var bottomLayout = bottomSCNode.GetLayout();
    bottomLayout.SetSubChartID(nextSubChartID);

    this.UpdateSubChartID(bottomSCNode, topSubChartID, nextSubChartID); // ,null);
    var subChart = this.AddSubChart(nextSubChartID, topSubChartID, dataObj, "");

    this.IncChangeCount();
    //    this.fChangeCount++;
  }

  SaveBreakInfo(topBoxDataObj, breakType, newName) {
    this.JournalPaginationChg();

    var childList = topBoxDataObj.GetChildList();

    var recordIDDef = topBoxDataObj.GetRecordIDFieldDef();
    if (!recordIDDef) return false;
    var TopBoxID = String(topBoxDataObj.GetFieldValue(recordIDDef));

    var newBreak = new QSubChartBreak();
    var dataDict = { type: breakType, parent: TopBoxID, children: [] };

    for (var aChildIdx in childList) {
      var theChild = childList[aChildIdx];
      dataDict["children"].push(String(theChild.GetFieldValue(recordIDDef)));
    }

    if (this.fManualPaginationDeltas == null) {
      this.fManualPaginationDeltas = [];
    }
    for (var aBreakIdx in this.fManualPaginationDeltas) {
      var theBreak = this.fManualPaginationDeltas[aBreakIdx];
      if (
        theBreak.GetBreakParent() === dataDict["parent"] &&
        theBreak.GetBreakChildren().length === dataDict["children"].length &&
        breakType != "rename"
      ) {
        //Replace duplicate breaks
        this.fManualPaginationDeltas.splice(aBreakIdx, 1);
        console.log("removed a duplicate insert/remove break");
        return;
      }
      if (
        theBreak.GetBreakParent() === dataDict["parent"] &&
        breakType == "rename" &&
        theBreak.fType == "rename"
      ) {
        this.fManualPaginationDeltas.splice(aBreakIdx, 1);
        console.log("Updated a rename break");
      }
    }
    newBreak.InitBreak(
      dataDict["type"],
      dataDict["parent"],
      dataDict["children"],
      new Date().toUTCString(),
      Globals._wsMgr.GetUserName()
    );
    if (newName) {
      newBreak.fName = newName;
    }

    this.fManualPaginationDeltas.push(newBreak);

    return newBreak;
  }

  /**
   * Restores an existing break to fManualPaginationDeltas, preserving
   * the original timestamp and user attribution.
   * Use this when reapplying breaks during refresh/sync operations.
   * @param {QSubChartBreak} existingBreak - The break to restore
   */
  RestoreBreakInfo(existingBreak) {
    if (!existingBreak) return null;

    this.JournalPaginationChg();

    if (this.fManualPaginationDeltas == null) {
      this.fManualPaginationDeltas = [];
    }
    this.fManualPaginationDeltas.push(existingBreak);
  }

  InsertSubChartBreak(targetLayout, dataObj, dataObjID, optimize) {
    var nextSubChartID = this.GetNextUID();
    var origSubChartID = targetLayout.GetSubChartID();

    targetLayout.SetSubChartFlag(enumSubChartFlag.drilldown);

    var c = targetLayout.Clone();
    c.SetChartHorzCentering(enumHorzCentering.centermiddle);
    c.SetChartVertCentering(enumVertCentering.centertop);
    c.SetSubChartID(nextSubChartID);
    c.SetSubChartFlag(enumSubChartFlag.drillup);
    c.SetBranchStyle(enumBranchStyle.tree);

    var newNode = this.AddSCNode(c, dataObj, dataObjID);

    //create new nodes for each holder for the sc top
    if (newNode.IsPositionSCNode()) {
      var holderNodes = this.GetHolderNodesForPosition(newNode);
      holderNodes.forEach(holderNode => {
        var holderObj = holderNode.GetDataObj();
        var holderLayout = holderNode.GetLayout();
        var node = this.FindSCNode(holderObj, nextSubChartID);
        if (!node) {
          var prevLayout = holderLayout.Clone();
          node = this.AddSCNode(prevLayout, holderObj, holderObj.GetObjectID());
        }
        var newLayout = node.GetLayout();
        newLayout.SetSubChartID(nextSubChartID);
      });
    }

    //  var nodeIndex = this.CreateIndexofSCNodes(origSubChartID);
    this.UpdateSubChartID(newNode, origSubChartID, nextSubChartID); //, nodeIndex);
    var subChart = this.AddSubChart(nextSubChartID, origSubChartID, dataObj, null);

    this.SetTopSubChart(dataObj, true);

    if (optimize) this.OptimizeSubchart2(nextSubChartID);
    //this.UpdateBranchStyle(newNode,true);

    this.IncChangeCount();
    //this.fChangeCount++;
    this.GetDoc().UpdateDocContext();
    return subChart;
  }

  ClearSubChart(subChartID, avoidEmployeeNodes = false) {
    var remainingNodes;
    if (subChartID == 0 || this.fNonChartNodes == null)
      remainingNodes = this.GetNodesForSubChart(subChartID, false);
    else remainingNodes = this.GetNonChartNodes(subChartID);
    var n = remainingNodes.length;
    for (var i = 0; i < n; i++) {
      var theNode = remainingNodes[i];
      var scID = theNode.GetSubChartID();
      var objID = theNode.GetDataObjID();
      this.RemoveSCNode(objID, scID);
      var delObj = theNode.GetDataObj();
      if (delObj != null && !(avoidEmployeeNodes && delObj.IsHolderObj())) {
        delObj.SetParent(null, -1);
        delObj.SetPersistent(false);
      }
    }

    var sc;
    if (subChartID == 0) sc = this.GetMasterPageSubChart();
    else sc = this.FindSubChart(subChartID);
    if (sc) {
      sc.ClearRootOrderLoad();
      sc.ClearRootOrder();
    }
  }

  RemoveSubChartBreak(parentLayout, dataObj, dataObjID, okToOptimize, avoidEmployeeNodes = false) {
    var parentSubChartID = parentLayout.GetSubChartID();
    parentLayout.SetSubChartFlag(enumSubChartFlag.nobreak);

    var index = this.FindSCSubNodeIndex(dataObjID, parentSubChartID);
    if (index != -1) {
      var childSCNode = this.GetIndexSCNode(index);
      var prevSubChartID = childSCNode.GetSubChartID();
      var numSCNodes = 0;

      //var doOptimize = false;
      if (okToOptimize) this.UpdateBranchRemoveSCBreak(childSCNode);

      this.RemoveSubChart(prevSubChartID);
      this.RemoveSCNode(dataObjID, prevSubChartID);
      this.UpdateSubChartID(childSCNode, prevSubChartID, parentSubChartID); //,null);

      // Boxes on the page but not connected to the main chart
      this.ClearSubChart(prevSubChartID, avoidEmployeeNodes);
      this.SetTopSubChart(dataObj, false);
    }

    this.IncChangeCount();
    this.GetDoc().UpdateDocContext();
    this.LogSubCharts("After Remove SubChart");
  }

  ClearChangeCount() {
    this.fChangeCount = 1;
  }

  IncChangeCount() {
    this.fChangeCount++;
  }

  SetTopSubChart(dataObj, setTopOfSubChart) {
    var isTop = 0;
    if (setTopOfSubChart) isTop = 1;

    var fieldDef = dataObj.GetFieldDefByID("TopOfSubChart");
    dataObj.SetFieldValue(fieldDef, isTop);
  }

  IsNonChartNode(scNode) {
    var dbObj = scNode.GetDataObj();
    var notInChart = false;

    if (dbObj) {
      var scID = scNode.GetSubChartID();
      var sc = this.FindSubChart(scID);
      if (sc == null) return false;
      var notInChart = !sc.IsInMainSubChart(dbObj);
    }

    return notInChart;
  }

  ForceOptimizeRootSC() {
    var sc = this.FindSubChart(this.fRootSubChartID);
    if (sc != null) sc.SetNeedOptimize(true);
  }

  RemoveAllSubChartBreaks(zeroSubsOnly) {
    StartTiming();
    ReportTiming("Prep Remove Breaks");

    var targetList = [];
    var n = this.GetSCNodeCount();
    this.fNonChartNodes = [];
    for (var i = 0; i < n; i++) {
      var scNode = this.GetIndexSCNode(i);
      var l = scNode.GetLayout();
      if (
        l.GetSubChartFlag() == enumSubChartFlag.drilldown &&
        (l.GetContainerType() == enumContainerType.nonmrb || l.GetDBObj()?.IsPositionObj()) &&
        !l.GetContainerObjID()
      )
        targetList.push(scNode);

      if (this.IsNonChartNode(scNode)) this.fNonChartNodes.push(scNode);
    }

    ReportTiming("Remove Breaks");
    n = targetList.length;
    for (var i = 0; i < n; i++) {
      var scNode = targetList[i];
      var dataObj = scNode.GetDataObj();
      var doRemove = true;
      var doOptimize = false;
      if (zeroSubsOnly) {
        doRemove = dataObj.CountSubs() === 0;
        /*
            if (!doRemove)
            {
                //Remove me if I have a break but I'm alone on the page
                //check if root object
                //var parentObj = dataObj.GetParent();
                //doRemove = parentObj == null;
                doOptimize = !doOptimize;
            }
            */
      }
      if (doRemove)
        this.RemoveSubChartBreak(scNode.GetLayout(), dataObj, scNode.GetDataObjID(), doOptimize);
    }
    this.fNonChartNodes = null;

    ReportTiming("Done Remove Breaks");
  }

  SetSaveScope(saveScope) {
    this.fSaveScope = saveScope;
  }

  GetSaveScope() {
    return this.fSaveScope;
  }

  GetCurrentTopObjPersonID() {
    var curSC = this.GetActiveSubChart();
    var topObj = curSC.GetTopDBObj();

    return topObj.GetObjectRecordID();
  }

  FilterObjects(setFilter) {
    var objDB = this.GetObjDB();
    var boxClass = objDB.GetClassByName("Box");
    var objMgr = boxClass.GetObjMgr();

    if (setFilter) objMgr.SetObjFilter("exclude", true);
    else {
      objMgr.SetObjFilter("include", false);
      return;
    }

    var saveScope = this.fSaveScope;

    if (saveScope == enumSaveScope.currentBranch) {
      var curSC = this.GetActiveSubChart();
      var topObj = curSC.GetTopDBObj();
      topObj["ignoreSCTop"] = true;
    }

    var singlePage = saveScope == enumSaveScope.currentPage;
    var scNodes = this.GetSCNodeListFiltered(false);
    var n = scNodes.length;
    for (var i = 0; i < n; i++) {
      var scNode = scNodes[i];
      var dbObj = scNode.GetDataObj();
      if (dbObj) {
        dbObj["objfilter"] = "include";

        if (singlePage) dbObj["ignoreSCTop"] = true;
      }
    }
  }

  GetSCNodeListFiltered(addMaster) {
    var nodeList = null;

    switch (this.fSaveScope) {
      case enumSaveScope.currentPage:
        var curSC = this.GetActiveSubChart();
        var subChartID = curSC.GetSubChartID();
        nodeList = this.GetNodesForSubChart(subChartID, false);
        break;
      case enumSaveScope.currentBranch:
        var curSC = this.GetActiveSubChart();
        nodeList = [];
        this.GetNodesForSubChartBranch(curSC, nodeList);
        break;
      case enumSaveScope.entireChart:
        nodeList = this.GetSCNodeList();
        addMaster = false;
        break;
      case enumSaveScope.background:
        nodeList = this.GetBackgroundNodes();
        addMaster = false;
    }

    if (addMaster && nodeList != null) {
      var masterList = this.GetBackgroundNodes();
      if (masterList) nodeList = nodeList.concat(masterList);
    }

    if (nodeList == null) {
      console.log("Shinola");
    }

    return nodeList;
  }

  GetSubchartListFiltered() {
    var scList = null;
    switch (this.fSaveScope) {
      case enumSaveScope.currentPage:
        var curSC = this.GetActiveSubChart();
        scList = [];
        scList.push(curSC);
        break;
      case enumSaveScope.currentBranch:
        var curSC = this.GetActiveSubChart();
        scList = [];
        this.GetSubChartBranch(curSC, scList);
        break;
      case enumSaveScope.entireChart:
        scList = this.fSubChartList;
        break;
    }

    return scList;
  }

  GetLoadedLevels() {
    var curSubChart = this.GetCurrentSubChart();
    return curSubChart.fLoadedLevels;
  }

  GetLoadedChainLevels() {
    var curSubChart = this.GetCurrentSubChart();
    return curSubChart.fChainLoaded; //TODO: Use getters on the subchart methods too
  }

  //=================================================================================================
  // Load & Save
  LoadFromJSON(json) {
    this.fUID = json["UID"];

    if (json["mpSubChart"]) {
      this.fMPSubChart = new QSubChart();
      this.fMPSubChart.SetSubChartMgr(this);
      this.fMPSubChart.LoadFromJSON(json["mpSubChart"]);
      this.fMPSubChart.DoInit();
    }

    if (json["subcharts"]) {
      var subchartList = json["subcharts"];
      for (var i = 0; i < subchartList.length; i++) {
        var subchartInfo = subchartList[i];
        var subChart = new QSubChart();
        subChart.SetSubChartMgr(this);
        subChart.LoadFromJSON(subchartInfo);
        this.fSubChartList.push(subChart);
      }
    }

    if (json["manualDeltas"]) {
      var manualDeltas = json["manualDeltas"];
      this.fManualPaginationDeltas = [];
      for (var i = 0; i < manualDeltas.length; i++) {
        var theBreak = manualDeltas[i];
        var aNewBreak = new QSubChartBreak();
        aNewBreak.LoadFromJSON(theBreak);
        this.fManualPaginationDeltas.push(aNewBreak); //ordering - should we splice here?
      }
    }

    // only master sc
    if (this.fSubChartList.length === 0 && this.fMPSubChart) {
      this.CreateRootSubChart();
      this.fLoadedMPTemplate = true;
    }
  }

  //=================================================================================================
  // Load & Save
  OutputToJSON(stream) {
    var scmObj = {};
    scmObj["UID"] = this.fUID;

    scmObj["mpSubChart"] = this.fMPSubChart.OutputToJSON(scmObj);

    var theDoc = this.GetDoc();
    var saveAsMPTemplate = theDoc.GetSaveAsMPTemplate();
    if (saveAsMPTemplate) return scmObj;

    var isStaticChart = !theDoc.IsServerChart() && !theDoc.GetIWizData().fIsLiveChart;
    if (isStaticChart) {
      scmObj["subcharts"] = [];
      var theList = this.GetSubchartListFiltered();
      for (var i in theList) {
        var subChart = theList[i];
        scmObj["subcharts"].push(subChart.OutputToJSON(stream));
      }
    }

    var manualDeltas = this.fManualPaginationDeltas;
    if (manualDeltas) {
      scmObj["manualDeltas"] = [];
      for (var aDeltaIdx in manualDeltas) {
        scmObj["manualDeltas"].push(manualDeltas[aDeltaIdx].OutputToJSON(stream));
      }
    } else {
      //export subcharts normally?
    }

    return scmObj;
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("SCUID", this.fUID, stream);
  }

  OutputChildElements(stream) {
    this.fMPSubChart.OutputToXML(stream);
    var theDoc = this.GetDoc();
    var saveAsMPTemplate = theDoc.GetSaveAsMPTemplate();
    if (saveAsMPTemplate) return;

    var theList = this.GetSubchartListFiltered();
    for (var i in theList) {
      var subChart = theList[i];
      subChart.OutputToXML(stream);
    }

    var manualDeltas = this.fManualPaginationDeltas;
    if (manualDeltas) {
      for (var aDeltaIdx in manualDeltas) {
        manualDeltas[aDeltaIdx].OutputToXML(stream);
      }
    } else {
      //export subcharts normally?
    }
  }

  LoadChildElements(objTree) {
    this.fUID = objTree.GetValueForChild("SCUID", true);
    var childList = objTree.GetChildOfTypeList("subchart");
    var n = childList.length;
    for (var i = 0; i < n; i++) {
      var subchartInfo = childList[i];
      var subChart = new QSubChart();
      subChart.SetSubChartMgr(this);
      subChart.LoadFromXML(subchartInfo);

      var scid = subChart.GetSubChartID();
      if (scid == 0) {
        this.fMPSubChart = subChart;
        subChart.DoInit();
      } else this.fSubChartList.push(subChart);
    }

    var manualBreakList = objTree.GetChildOfTypeList("break");

    this.fManualPaginationDeltas = [];
    for (var aBreakIdx in manualBreakList) {
      var theBreak = manualBreakList[aBreakIdx];
      var aNewBreak = new QSubChartBreak();
      aNewBreak.LoadFromXML(theBreak);
      this.fManualPaginationDeltas.push(aNewBreak); //ordering - should we splice here?
    }

    // Must be a master page template (n==1)
    if (n == 1) {
      this.CreateRootSubChart();
      this.fLoadedMPTemplate = true;
    }
  }

  RemoveFieldReferences(fieldRefList, updateRef = false) {
    var n = this.GetNumSubCharts();
    var plm = this.fDoc.GetPageLayoutMgr();
    for (var i = 0; i < n; i++) {
      var s = this.fSubChartList[i];
      s.RemoveFieldReferences(fieldRefList, updateRef);
    }
    var l = this.GetSCNodeList();
    var n = l.length;

    for (var i = 0; i < n; i++) {
      var aNode = l[i];
      aNode.RemoveFieldReferences(fieldRefList, updateRef);
      var theNode = plm.FindNodeFromDataObjID(aNode.fDataObjID);
      if (theNode && theNode.fChartBox) {
        theNode.fChartBox.ForceLayoutRecalc();
      }
    }
  }

  GetRootSubChartID() {
    return this.fRootSubChartID;
  }

  GetFilterRootSCID(filterRoot) {
    var thedoc = this.GetDoc();
    var layoutMgr = thedoc.GetLayoutMgr();
    var scID = layoutMgr.FindSCID(filterRoot);
    return scID;
  }

  WireSubCharts(objDB, filterRoot) {
    var doc = this.GetDoc();
    var className = doc.IsPositionDocument() ? enumObjClassNames.position : enumObjClassNames.box;
    var hierarchyClass = objDB.GetClassByName(className);
    var n = this.GetNumSubCharts();
    var childList = [];
    var validSCList = [];

    //Create an index for fast lookup on subchartid
    var subChartIdx = new QGenericIndex();
    subChartIdx.InitIndex();
    for (var i = 0; i < n; i++) {
      var s = this.fSubChartList[i];
      var scid = s.GetSubChartID();
      subChartIdx.AddToIndex(s, scid);
    }
    var fieldID = s.GetSubChartFieldID();

    var filterRootSCID = null;
    if (filterRoot != null) filterRootSCID = this.GetFilterRootSCID(filterRoot);

    //Loop through subchart array and create subchart tree
    for (var i = 0; i < n; i++) {
      var s = this.fSubChartList[i];
      //Create new subchart object
      s.DoInit();
      var scid = s.GetSubChartID();
      var pscid = s.GetSubChartParentID();
      var parentSubChart = subChartIdx.FindObject(pscid);

      //No parent subchart object - this is our root.
      //var setInitialRootBox = false;

      if (parentSubChart == null) this.fRootSubChartID = scid;

      // Wire DB Obj Ref
      var topObjID = s.GetTopDBObjID();
      var topObj = null;
      if (topObjID == null) {
        //Handling the case where the ID is not present, but the reference may exist.
        var roots = hierarchyClass.GetRootObjs();
        if (roots && roots.length > 0) topObj = roots[0];
      } else {
        topObj = hierarchyClass.RetrieveObject(topObjID);
      }

      var validSubChart = true;
      if (!this.fLoadedMPTemplate) {
        // Check for missing db top obj
        if (topObj == null) {
          validSubChart = false;
          if (scid == filterRootSCID) {
            validSubChart = true;
            topObj = filterRoot;
            this.fRootSubChartID = scid;
          }
        } else if (filterRoot === topObj) {
          this.fRootSubChartID = scid;
        }
      }

      if (validSubChart) {
        s.SetParent(parentSubChart);
        if (topObj) s.SetTopDBObj(topObj);
        if (s.fDataObjIDArr) {
          var DBObjs = s.fDataObjIDArr
            .map(function (a) {
              return hierarchyClass.RetrieveObject(a);
            })
            .filter(function (a) {
              return a != null;
            });
          s.SetTopDBObjArr(DBObjs);
        }
        childList.push(s);
        validSCList.push(s);
      } else if (this.fRootSubChartID == scid) {
        //we filtered out a valid subchart!
        console.log("Filtered out root subchart.");
        this.fRootSubChartID = null;
      }
    }

    this.fSubChartList = validSCList;

    // Wire children
    var failList = [];
    var nc = childList.length;
    for (var j = 0; j < nc; j++) {
      var aChild = childList[j];
      var childParentID = aChild.GetSubChartParentID();
      var parent = subChartIdx.FindObject(childParentID);
      if (parent != null) {
        var result = parent.AddChildSubChart(aChild);
        if (result === "failure") failList.push(aChild);
      }
    }

    n = failList.length;
    for (var i = 0; i < n; i++) {
      var f = failList[i];
      var index = this.fSubChartList.indexOf(f);
      this.fSubChartList.splice(index, 1);
    }

    var numSubCharts = this.fSubChartList.length;
    if (numSubCharts === 0) {
      var ns = new QSubChart();
      var scid = 1;
      var pscid = null;
      ns.InitSubChart(scid, pscid, filterRoot, "", fieldID, this);
      this.fSubChartList = [ns];
    }
    if (this.fRootSubChartID == null) {
      console.log("Error loading subcharts");
      this.fRootSubChartID = this.fSubChartList[0].GetSubChartID();
    }
  }

  FindSubChartByTopObj(topObj) {
    if (!topObj) return null;
    const matchList = this.FindSCSubNodesFromDataObjID(topObj.GetObjectID());

    for (let node of matchList) {
      const associatedSC = this.FindSubChart(node.GetSubChartID());
      if (associatedSC?.GetTopDBObj() === topObj) {
        return associatedSC;
      }
    }

    return null;
  }

  //=================================================================================================
  // FindSubChartID
  FindSubChartID(dataObj, topOfSubchart) {
    var scID = null;
    var dataObjID = dataObj.GetObjectID();
    var matchList = this.FindSCSubNodesFromDataObjID(dataObjID);
    var m = matchList.length;

    var targetSCNode = null;

    if (m == 1) targetSCNode = matchList[0];
    else if (m == 2) {
      targetSCNode = matchList[0];
      var target2SCNode = matchList[1];
      var topBreak = targetSCNode.TopOfBreak();
      if (topOfSubchart) targetSCNode = topBreak ? target2SCNode : targetSCNode;
      else targetSCNode = topBreak ? targetSCNode : target2SCNode;
    }

    if (targetSCNode) scID = targetSCNode.GetSubChartID();

    return scID;
  }

  FindSCNodeList(scID) {
    return this.fSCNodeIndex.get(scID) || null;
  }

  CreateSCNodeIndex() {
    this.fSCNodeIndex = new Map();

    var n = this.GetSCNodeCount();
    for (var i = 0; i < n; i++) {
      var scn = this.GetIndexSCNode(i);
      var scID = scn.GetSubChartID();

      var scNodeList = this.fSCNodeIndex.get(scID) || null;
      if (scNodeList == null) {
        scNodeList = new QSCNodeList(scID);
        this.fSCNodeIndex.set(scID, scNodeList);
      }

      scNodeList.push(scn);
    }
  }

  ClearSCNodeIndex() {
    this.fSCNodeIndex = null;
  }

  CopyBoxSort(
    subchartRules,
    rootObj // ,breakOverflow)
  ) {
    var currentObjDB = this.GetObjDB();
    var priorDoc = this.GetPriorDoc(subchartRules);
    if (!priorDoc) return;

    var priorObjDB = priorDoc.GetObjDB();

    var pboxClass = priorObjDB.GetClassByName("Box");
    var priorIDfieldDef = this.GetRecordIDField(pboxClass);

    var ppersonIDIndex = new QIndex();
    ppersonIDIndex.InitIndex(pboxClass, priorIDfieldDef, true, false);

    var cboxClass = currentObjDB.GetClassByName("Box");
    var cidFieldDef = this.GetRecordIDField(cboxClass);

    this.DoCopyBoxSort(rootObj, cidFieldDef, priorIDfieldDef, ppersonIDIndex);
  }

  DoIDMatch(matchID, idFieldDef, childList) {
    if (matchID == null) return null;

    matchID = this.PrepVal(matchID); // .toString();
    var n = childList.length;
    for (var i = 0; i < n; i++) {
      var aChild = childList[i];
      var v = aChild.GetFieldValue(idFieldDef);
      if (v) {
        v = this.PrepVal(v); //.toString();
        if (v == matchID) return aChild;
      }
    }

    return null;
  }

  DoCopyBoxSort(rootObj, idFieldDef, priorIDfieldDef, priorIndex) {
    var currentID = rootObj.GetFieldValue(idFieldDef);
    var matchObj = priorIndex.FindObject(currentID);
    var newOrder = null;

    if (matchObj) {
      var priorChildList = matchObj.GetChildList(false);
      if (priorChildList && priorChildList.length > 0) {
        var pChildOrder = priorChildList.slice(0);
        var curChildList = rootObj.GetChildList(false);
        var cChildOrder = null;
        if (curChildList == null) cChildOrder = [];
        else cChildOrder = curChildList.slice(0);

        newOrder = [];
        var curP = pChildOrder.shift();
        while (curP && cChildOrder.length > 0) {
          var pID = curP.GetFieldValue(priorIDfieldDef);
          var matchObj = this.DoIDMatch(pID, idFieldDef, cChildOrder);
          if (matchObj) {
            var index = cChildOrder.indexOf(matchObj);
            cChildOrder.splice(index, 1);
            newOrder.push(matchObj);
          }

          curP = pChildOrder.shift();
        }

        var cur = cChildOrder.shift();
        while (cur) {
          newOrder.push(cur);
          cur = cChildOrder.shift();
        }

        if (newOrder) rootObj.SwapChildList(newOrder);
      }
    }

    var n = rootObj.GetNumChildren();
    for (var i = 0; i < n; i++) {
      var c = rootObj.GetIndexChild(i);
      this.DoCopyBoxSort(c, idFieldDef, priorIDfieldDef, priorIndex);
    }
  }

  SyncSortOverridesFromTree(subchartRules, rootObj) {
    var theDoc = this.GetDoc();
    var iWizData = theDoc.GetIWizData();
    if (!iWizData) return;

    var sortOverrides = iWizData.GetSortOverrides();
    if (!sortOverrides) return;

    var priorDoc = this.GetPriorDoc(subchartRules);
    if (!priorDoc) return;

    var currentObjDB = this.GetObjDB();
    var cboxClass = currentObjDB.GetClassByName("Box");
    var cidFieldDef = this.GetRecordIDField(cboxClass);

    this.DoSyncSortOverrides(rootObj, cidFieldDef, iWizData, sortOverrides);
  }

  DoSyncSortOverrides(rootObj, idFieldDef, iWizData, sortOverrides) {
    var parentRecordID = rootObj.GetFieldValue(idFieldDef);
    if (parentRecordID && sortOverrides[String(parentRecordID)]) {
      var children = rootObj.GetChildList(false);
      if (children && children.length > 0) {
        var childRecordIDs = [];
        for (var i = 0; i < children.length; i++) {
          var childID = children[i].GetFieldValue(idFieldDef);
          if (childID) childRecordIDs.push(String(childID));
        }
        iWizData.SetSortOverrideForParent(String(parentRecordID), childRecordIDs);
      } else {
        iWizData.ClearSortOverrideForParent(String(parentRecordID));
      }
    }

    var nChildren = rootObj.GetNumChildren();
    for (var ci = 0; ci < nChildren; ci++) {
      this.DoSyncSortOverrides(rootObj.GetIndexChild(ci), idFieldDef, iWizData, sortOverrides);
    }
  }

  ApplySortOverrides(rootObj) {
    var theDoc = this.GetDoc();
    var iWizData = theDoc.GetIWizData();
    if (!iWizData) return;

    var sortOverrides = iWizData.GetSortOverrides();
    if (!sortOverrides) return;
    var currentObjDB = this.GetObjDB();
    var cboxClass = currentObjDB.GetClassByName("Box");
    var cidFieldDef = this.GetRecordIDField(cboxClass);

    this.DoApplySortOverrides(rootObj, cidFieldDef, sortOverrides);
  }

  DoApplySortOverrides(rootObj, idFieldDef, sortOverrides) {
    var parentRecordID = rootObj.GetFieldValue(idFieldDef);
    if (parentRecordID) {
      var overrideKey = String(parentRecordID);
      var childOrder = sortOverrides[overrideKey];
      if (childOrder) {
        var curChildren = rootObj.GetChildList(false);
        if (curChildren && curChildren.length > 0) {
          var remaining = curChildren.slice(0);
          var newOrder = [];

          for (var i = 0; i < childOrder.length; i++) {
            var targetID = childOrder[i];
            var matchObj = this.DoIDMatch(targetID, idFieldDef, remaining);
            if (matchObj) {
              remaining.splice(remaining.indexOf(matchObj), 1);
              newOrder.push(matchObj);
            }
          }

          // Append any children not in the override (new employees)
          for (var j = 0; j < remaining.length; j++) {
            newOrder.push(remaining[j]);
          }

          if (newOrder.length > 0) rootObj.SwapChildList(newOrder);
        }
      }
    }

    var nChildren = rootObj.GetNumChildren();
    for (var ci = 0; ci < nChildren; ci++) {
      this.DoApplySortOverrides(rootObj.GetIndexChild(ci), idFieldDef, sortOverrides);
    }
  }

  CopyAssistBranchStyles(subchartRules) {
    var persistAssist = subchartRules.GetPersistAssist();
    var priorDoc = this.GetPriorDoc(subchartRules);
    if (!persistAssist || !priorDoc) return;

    var priorSCM = priorDoc.GetSubChartMgr();
    var priorObjDB = priorDoc.GetObjDB();
    var pboxClass = priorObjDB.GetClassByName("Box");
    var priorIDfieldDef = this.GetRecordIDField(pboxClass);

    var pIndex = priorSCM.CreateSCNodeList(priorIDfieldDef, true, false);
    var cList = this.CreateSCNodeList(null, false, false);
    var currentObjDB = this.GetObjDB();
    var cboxClass = currentObjDB.GetClassByName("Box");
    var cidFieldDef = this.GetRecordIDField(cboxClass);
    var nameDef = cboxClass.GetFieldDefByID("Name");
    if (!nameDef) nameDef = cidFieldDef;

    var n = cList.length;
    var theDoc = this.GetDoc();

    // Copy assistant branch styles from original chart by finding a match
    for (var i = 0; i < n; i++) {
      var aNode = cList[i];
      var scFlag = aNode.GetSubChartFlag();
      var dbObj = aNode.GetDataObj();
      var id = this.GetSCLocator(dbObj, scFlag);

      var matchSCNode = pIndex.FindObject(id);
      if (matchSCNode == null) {
        if (scFlag == enumSubChartFlag.nobreak) scFlag = enumSubChartFlag.drilldown;
        else scFlag = enumSubChartFlag.nobreak;

        id = this.GetSCLocator(dbObj, scFlag);
        matchSCNode = pIndex.FindObject(id);
      }

      var finalStyle = null;

      if (matchSCNode) {
        var priorObj = matchSCNode.GetDataObj();
        var priorParentObj = priorObj.GetParent();
        var matchStyle = matchSCNode.GetBranchStyle();
        var curStyleType = IsAssistantStyle(matchStyle);
        if (curStyleType != null) finalStyle = matchStyle;
      }

      if (finalStyle != null) {
        aNode.SetBranchStyle(finalStyle);
        this.DiagnosticLog(
          "Assistant Style",
          "Copy",
          "Copied style: " +
            appstr(finalStyle) +
            " to parent: " +
            priorParentObj.GetFieldValue(nameDef) +
            "."
        );
      }
    }
  }

  ForceBranchStyle(aNode, theStyle) {
    var l = aNode.GetLayout();
    var scNode = l.GetSCNodeRef();

    aNode.SetBranchStyle(theStyle);
    var pObj = GetNodeParentObj(scNode);
    if (pObj == null) return;

    var scID = scNode.GetSubChartID();
    var n = pObj.GetNumChildren();
    for (var i = 0; i < n; i++) {
      var cObj = pObj.GetIndexChild(i);
      var scNodes = this.FindSCSubNodesFromDataObj(cObj);
      var m = scNodes.length;
      for (var j = 0; j < m; j++) {
        var scNode2 = scNodes[j];
        var scID2 = scNode2.GetSubChartID();
        if (scID == scID2) {
          var bStyle = scNode2.GetBranchStyle();
          if (IsAssistantStyle(bStyle) == null) scNode2.SetBranchStyle(theStyle);
        }
      }
    }
  }

  SetPeerAssist(aNode, peerAssistOption) {
    var l = aNode.GetLayout();
    var scNode = l.GetSCNodeRef();

    var pObj = GetNodeParentObj(scNode);
    if (pObj == null) return;

    var peerBranchStyle =
      peerAssistOption == enumBSFlagOptions.leftpeerassist
        ? enumBranchStyle.assistantpeerleft
        : enumBranchStyle.assistantpeerright;
    scNode.SetBranchStyle(peerBranchStyle);

    var scID = scNode.GetSubChartID();
    var n = pObj.GetNumChildren();
    for (var i = 0; i < n; i++) {
      var cObj = pObj.GetIndexChild(i);
      var scNodes = this.FindSCSubNodesFromDataObj(cObj);
      var m = scNodes.length;
      for (var j = 0; j < m; j++) {
        var scNode2 = scNodes[j];
        var scID2 = scNode2.GetSubChartID();
        if (scID == scID2 && scNode2 != scNode) {
          var bStyle2 = scNode2.GetBranchStyle();
          if (bStyle2 == peerBranchStyle) scNode2.SetBranchStyle(enumBranchStyle.assistantright);
        }
      }
    }
  }

  CopyBranchStyles(subchartRules, breakOverflow) {
    var persistBS = subchartRules.GetPersistBranchStyle();
    var priorDoc = this.GetPriorDoc(subchartRules);
    if (!priorDoc) return;

    var priorSCM = priorDoc.GetSubChartMgr();
    var priorObjDB = priorDoc.GetObjDB();
    var pboxClass = priorObjDB.GetClassByName("Box");
    var priorIDfieldDef = this.GetRecordIDField(pboxClass);

    var pIndex = priorSCM.CreateSCNodeList(priorIDfieldDef, true, false);
    var cList = this.CreateSCNodeList(null, false, false);
    var currentObjDB = this.GetObjDB();
    var cboxClass = currentObjDB.GetClassByName("Box");
    var cidFieldDef = this.GetRecordIDField(cboxClass);
    var nameFieldDef = cboxClass.GetFieldDefByID("Name");

    var missList = [];

    var matchCase = this.GetMatchCase();

    // Copy branch styles from original chart by finding a match
    for (var i in cList) {
      var aNode = cList[i];
      var scFlag = aNode.GetSubChartFlag();
      var dbObj = aNode.GetDataObj();
      var id = this.GetSCLocator(dbObj, scFlag);

      var matchSCNode = pIndex.FindObject(id);
      var matchStyle = null;
      var parentObj = dbObj.GetParent();
      var assistStyle = null;
      var priorParentObj = null;

      if (matchSCNode) {
        var priorObj = matchSCNode.GetDataObj();
        priorParentObj = priorObj.GetParent();

        var curStyle = aNode.GetBranchStyle();
        assistStyle = IsAssistantStyle(curStyle);
        if (assistStyle == null) {
          matchStyle = matchSCNode.GetBranchStyle();
          assistStyle = IsAssistantStyle(matchStyle);
        }

        var l = matchSCNode.GetLayout();
      }

      if (assistStyle == null) {
        if (!parentObj || !priorParentObj) {
          this.DiagnosticLog(
            "Branch Style",
            "Copy",
            "Attempted to copy branch style for invalid subordinate: " +
              dbObj.GetObjectRecordID() +
              "."
          );
          continue;
        }

        var styleSet = parentObj["bstyle"];
        if (styleSet != null) aNode.SetBranchStyle(styleSet);
        else {
          var gotMatch = false;
          if (matchStyle != null) {
            var sameParent = SameParent(
              parentObj,
              priorParentObj,
              cidFieldDef,
              priorIDfieldDef,
              matchCase
            );
            if (sameParent) {
              parentObj["bstyle"] = matchStyle;
              aNode.SetBranchStyle(matchStyle);
              //set the subchart as not needing optimize.
              var theSubchartID = aNode.GetSubChartID();
              var theSubchart = this.FindSubChart(theSubchartID);
              theSubchart.SetNeedOptimize(false);
              theSubchart.fBranchStyleOverride = true;
              if (matchStyle != curStyle) {
                var branchStyleName = "Unknown";
                for (var aBranchStyleName in enumBranchStyle) {
                  if (enumBranchStyle[aBranchStyleName] == matchStyle) {
                    branchStyleName = aBranchStyleName;
                    break;
                  }
                }
                this.DiagnosticLog(
                  "Branch Style",
                  "Copy",
                  "User set branch style " +
                    appstr(branchStyleName) +
                    " for '" +
                    parentObj.GetFieldValue(nameFieldDef) +
                    "' direct reports."
                );
              }
              gotMatch = true;
            }
          }

          if (!gotMatch) missList.push(aNode);
        }
      }
    }

    // Process the missList and see if any parent's got tagged with a branch style
    var missList2 = [];
    for (var i in missList) {
      var aNode = missList[i];
      var dbObj = aNode.GetDataObj();
      var parentObj = dbObj.GetParent();
      var bStyle = parentObj["bstyle"];
      if (bStyle != null) aNode.SetBranchStyle(bStyle);
      else missList2.push(aNode);
    }

    // Still don't have a branch style...
    for (var i in missList2) {
      var aNode = missList2[i];
      var parentObj = dbObj.GetParent();
      var bStyle = parentObj["bstyle"];
      if (bStyle == null) {
        bStyle = DetermineBranchStyleNoChildren(parentObj, null);
        parentObj["bstyle"] = bStyle;
      }
      aNode.SetBranchStyle(bStyle);
    }
  }

  GetSCLocator(dbObj, scFlag) {
    var id = dbObj.GetObjectRecordID();
    id = this.PrepVal(id); //.toString().toLowerCase();
    scFlag = scFlag.toString();
    id = id + "+" + scFlag;

    return id;
  }

  AnyLayoutLocked() {
    var n = this.GetSCNodeCount();
    for (var i = 0; i < n; i++) {
      var scn = this.GetIndexSCNode(i); // fNodeList[i];
      if (scn.IsLayoutLocked()) return true;
    }

    return false;
  }

  CopyBoxOverrides(subchartRules) {
    //TODO: Shouldn't this then just be a method of QLayoutMgr?
    var priorDoc = this.GetPriorDoc(subchartRules);
    var layoutMgr = this.GetDoc().GetLayoutMgr();
    if (priorDoc != null) {
      let priorLayoutMgr = priorDoc.GetLayoutMgr();
      let priorOverrides = priorLayoutMgr.fOverrideList;
      layoutMgr.fOverrideList = priorOverrides;
    }
    layoutMgr.ApplyOverrides(true);
  }

  ReformContainerSubchart(theBottomNode, topSCID) {
    //Called on the 'bottom' of the two nodes.
    var doc = this.fDoc;
    var childrenSCID = theBottomNode.GetSubChartID();
    var oldSubChart = this.FindSubChart(childrenSCID);
    var parentSubChart = this.FindSubChart(topSCID);
    var dataObj = theBottomNode.GetDataObj();
    oldSubChart.RemoveTopDBObj(theBottomNode.GetDataObj());

    //this failed me when I moved out of a group onto a box on the same level - below it
    //if (dataObj.GetParent() && dataObj.GetParent() != oldSubChart.GetTopDBObj() && dataObj.GetParent() != parentSubChart.GetTopDBObj())
    //    return;

    doc.GroupNodes([theBottomNode], true, null);
    var nextSubChartID = this.GetNextUID();

    var newSubChart = this.AddSubChart(nextSubChartID, topSCID, dataObj, "");
    this.UpdateSubChartID(theBottomNode, childrenSCID, nextSubChartID);
    //theBottomNode.GetLayout().SetSubChartFlag(enumSubChartFlag.drillup);
    //Remove the data obj reference from the subchart if applicable.
    var dataObjChildren = dataObj.GetChildList(true);
    var subChartsToRemove = [];
    for (var childIdx = 0; childIdx < oldSubChart.ChildCount(); childIdx++) {
      var theChildSubchart = oldSubChart.GetIndexChild(childIdx);
      if (dataObjChildren.indexOf(theChildSubchart.GetTopDBObj()) > -1) {
        subChartsToRemove.push(theChildSubchart);
        newSubChart.AppendChildSubChart(theChildSubchart);
        theChildSubchart.SetParent(newSubChart);
      }
    }
    for (var aSubChart in subChartsToRemove) oldSubChart.RemoveChild(subChartsToRemove[aSubChart]);

    if (oldSubChart.GetTopDBObjID() == theBottomNode.GetDataObjID()) {
      if (oldSubChart.fDataObjArr && oldSubChart.fDataObjArr.length > 0) {
        oldSubChart.SetTopDBObj(oldSubChart.fDataObjArr[0]);
      } else {
        //remove subchart
        //TODO: This may be where the old container gets removed
        this.RemoveSubChart(childrenSCID);
      }
    }

    this.IncChangeCount();
  }

  ShowSubChartNum() {
    var theDoc = this.GetDoc();
    return theDoc.ShowSubChartNum();
  }

  CopyPersistBoxes(subchartRules) {
    var priorDoc = this.GetPriorDoc(subchartRules);
    if (priorDoc == null) return;

    var priorSCM = priorDoc.GetSubChartMgr();
    var priorObjDB = priorDoc.GetObjDB();
    var pboxClass = priorObjDB.GetClassByName("Box");
    var priorIDfieldDef = this.GetRecordIDField(pboxClass);

    var theList = priorSCM.CreateSCNodeList(priorIDfieldDef, false, true);
    var n = theList.length;

    var currentObjDB = this.GetObjDB();
    var cboxClass = currentObjDB.GetClassByName("Box");
    var cPersonIDDef = this.GetRecordIDField(cboxClass);

    // Get a list of all persistent dbobjs
    // Add dbobjs to new DB
    var persistList = [];
    var newObjList = [];

    var u = 1;
    for (var i = 0; i < n; i++) {
      var aNode = theList[i];
      var priorDBObj = aNode.GetDataObj();
      if (priorDBObj != null) {
        var doPersist = priorDBObj.GetPersistStatus(null);
        if (doPersist == enumPersistStatus.persist) {
          var v = "PERSIST" + u.toString();
          u = u + 1;
          priorDBObj.SetFieldValue(priorIDfieldDef, v);
          persistList.push(priorDBObj);

          var newDataObj = cboxClass.AddNewObject();
          newDataObj.SetFieldValue(cPersonIDDef, v);

          newDataObj.TransferForeign(priorDBObj);
          newObjList.push(newDataObj);
        }
      }
    }

    // Wire new dbobjs
    n = newObjList.length;
    var cPersonIDIndex = new QIndex();
    cPersonIDIndex.InitIndex(cboxClass, cPersonIDDef, true, false);
    for (var i = 0; i < n; i++) {
      var priorObj = persistList[i];
      var parentObj = priorObj.GetParent();
      if (parentObj) {
        var superID = parentObj.GetFieldValue(priorIDfieldDef);
        if (superID != null) {
          var cParentObj = cPersonIDIndex.FindObject(superID);
          if (cParentObj != null) {
            var newObj = newObjList[i];
            newObj.SetParent(cParentObj, -1);
          }
        }
      }
    }
  }

  LogSubCharts(msg) {
    return;
    console.log(msg);
    //    console.log("Nodes:");
    msg = "";
    var nodeWithObjectIDs = [];
    var nodeWithoutObjectIDs = [];
    for (var i = 0; i < this.fNodeList.length; i++) {
      var arrowStr = "";
      if (this.fNodeList[i].GetSubChartFlag() === enumSubChartFlag.drillup) arrowStr = "\u2191";
      if (this.fNodeList[i].GetSubChartFlag() === enumSubChartFlag.drilldown) arrowStr = "\u2193";

      if (this.fNodeList[i].fDataObj) {
        msg +=
          "" +
          this.fNodeList[i].fDataObjID +
          ":" +
          this.fNodeList[i].GetSubChartID() +
          arrowStr +
          " ";
        nodeWithObjectIDs.push(this.fNodeList[i].fDataObjID);
      } else {
        msg +=
          "[" +
          this.fNodeList[i].fDataObjID +
          ":" +
          this.fNodeList[i].GetSubChartID() +
          arrowStr +
          "] ";
        nodeWithoutObjectIDs.push(this.fNodeList[i].fDataObjID);
      }
    }
    //    console.log("Nodes: " + nodeWithObjectIDs + " <" + nodeWithoutObjectIDs + ">");
    console.log("Nodes: " + msg);

    for (i = 0; i < this.fSubChartList.length; i++) {
      var nodeList = this.GetNodesForSubChart(this.fSubChartList[i].fSubChartID, false);
      this.fSubChartList[i].LogSubChart(nodeList);
    }
  }

  SerializeBreaks() {
    var breakList = this.fManualPaginationDeltas;
    var JSONList = [];
    for (var aBreakIdx in breakList) {
      var theBreak = breakList[aBreakIdx];
      JSONList.push(theBreak.OutputToJSON());
    }
    return JSONList;
  }

  RestoreBreaks(breaksJSON) {
    this.JournalPaginationChg();
    var SCBreakList = [];
    for (var json of breaksJSON) {
      var restoreBreak = new QSubChartBreak();
      restoreBreak.LoadFromJSON(json);
      SCBreakList.push(restoreBreak);
    }
    this.fManualPaginationDeltas = SCBreakList;
  }

  SetCollapsedState() {
    var rootSubChart = this.GetIndexSubChart(0);
    rootSubChart["collapsed"] = false;
    var n = this.GetNumSubCharts();
    for (var i = 1; i < n; i++) {
      var sc = this.GetIndexSubChart(i);
      var level2 = sc.GetSubChartParent() == rootSubChart;
      sc["collapsed"] = !level2;
    }
  }
}
